<template>
  <v-container>

    <v-row>
      <v-col cols="12" md="8">

        <div class="audience-main-wrapper">
         
        <!-- Inline Presentation Mode -->
            
        <!-- Webinar-Info über dem Video -->
        <div class="mb-3">
          <h1 class="text-red" v-if="terminData.beendet">Webinar wurde beendet</h1>
          <span v-if="terminData && terminData.webi_title">
            <h2 style="color: #3d1b70;">{{terminData.webi_title}} </h2>
            <div style="color: #666; font-size: 14px;">Beginn: {{ terminData.beginn }} | Dozent: {{ terminData.dozent }}</div>
          </span>
        </div>
        
        <div
          v-if="!hasAdminVideo && !hasAdminAudio && showAutoConnectLoader"
          class="admin-video-loader my-4"
        >
          <v-progress-circular
            indeterminate
            color="primary"
            size="28"
            class="mr-3"
          />
          <div>
            <div class="font-weight-medium">Dozenten-Video wird in Kürze gestartet …</div>
            <div class="text-caption text-medium-emphasis">
              <span v-if="autoConnectMessage">{{ autoConnectMessage }}</span>
              <span v-else>Bitte warten Sie einen Moment, bis die Übertragung startet.</span>
            </div>
          </div>
        </div>

        <v-alert
          v-if="showBrowserTokenConflict"
          type="warning"
          variant="tonal"
          prominent
          class="my-4"
        >
          <v-alert-title class="text-h6 mb-2">
            Diese Teilnahme ist bereits auf einem anderen Gerät aktiv
          </v-alert-title>
          <div class="text-body-1 mb-4">
            Wenn Sie das Webinar auf diesem Browser sehen möchten, klicken Sie auf "Webinar hier starten". 
            Die Übertragung im anderen Browser-Tab wird dann beendet und hier gestartet.
          </div>
          <v-btn
            color="primary"
            size="large"
            prepend-icon="mdi-play-circle"
            @click="overrideBrowserToken"
          >
            Webinar hier starten
          </v-btn>
        </v-alert>

        <v-alert
          v-if="showAudienceOverbookedError"
          type="error"
          variant="tonal"
          prominent
          class="my-4"
        >
          <div class="text-body-1">
            Das Webinar ist leider technisch, wegen Überfüllung nicht zu erreichen.
            Tut uns leid wir arbeiten schon an einem Nachholtermin. Sie erhalten eine E-Mail, wenn der Termin für Sie bereitgestellt wird.
          </div>
        </v-alert>

        <div
          v-if="audioPlaybackBlocked"
          class="audio-unlock-banner my-4"
        >
          <v-icon
            size="28"
            color="red-darken-2"
            class="mr-3"
          >
            mdi-volume-off
          </v-icon>
          <div class="flex-grow-1">
            <div class="font-weight-medium">
              Audio konnte nicht automatisch gestartet werden.
            </div>
            <div class="text-caption text-medium-emphasis">
              Bitte klicken Sie auf „Ton aktivieren“, damit der Dozenten-Ton abgespielt wird.
            </div>
          </div>
          <v-btn
            color="primary"
            variant="tonal"
            class="ml-4"
            @click="unlockAudioPlayback"
          >
            Ton aktivieren
          </v-btn>
        </div>

        <div :style="{ 
          position: 'relative', 
          width: '100%',
          marginLeft: baseStore.isMobile ? '0' : '0px'
        }">
          
          <!-- Wenn Präsentation noch nicht gestartet: Admin Video füllt ganzen Container -->
          <div
            v-if="!presentationStarted" 
            id="admin-videos-fullsize"
            class="audience-video-stage"
          >
            
            <!-- Overlay wenn kein Admin-Video -->
            <div
              v-if="!hasAdminVideo"
              class="no-admin-overlay"
              style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%); display: flex; align-items: center; justify-content: center; flex-direction: column; border-radius: 0px; z-index: 5;"
            >
              <!-- Dozentenbild, falls vorhanden, sonst Icon -->
              <div class="dozent-avatar-wrapper">
              
                <v-img
                  v-if="dozentImageSrc"
                  :src="dozentImageSrc"
                  :alt="terminData.dozent"
                  width="160"
                  height="160"
                  cover
                  class="dozent-avatar-image"
                />
                <div v-else class="dozent-avatar-fallback">
                  <v-icon size="80" color="white" style="opacity: 0.9;">mdi-video-off</v-icon>
                </div>
              </div>
             <span v-if="!terminData.isStarted && terminData.open && !startButtonPressed">
                <div style="color: white; font-size: 36px; font-weight: bold; text-align: center; padding: 30px; letter-spacing: 1px;">
                  Das Webinar wird um {{ terminData.beginn }} Uhr gestartet
                  <div v-if="baseStore.isMobile" style="color: rgba(255,255,255,0.8); font-size: 18px; margin-top: 8px; margin-bottom: 32px;">
                 Zum starten klicken Sie auf "Webinar jetzt starten"
                </div>
                </div>
               
              </span>
              <span v-if="terminData.isStarted && terminData.open && !startButtonPressed">
                <div style="color: white; font-size: 36px; font-weight: bold; text-align: center; padding: 20px; letter-spacing: 1px;">
                  Das Webinar ist bereits gestartet
                </div>
                <div v-if="baseStore.isMobile" style="color: rgba(255,255,255,0.8); font-size: 18px; margin-top: 8px; margin-bottom: 32px;">
                 Klicken Sie auf "Webinar jetzt starten" 
                </div>
                </span>
                <span v-if="!terminData.isStarted && terminData.open && startButtonPressed">
                <div style="color: white; font-size: 36px; font-weight: bold; text-align: center; padding: 20px; letter-spacing: 1px;">
                  Bitte haben Sie etwas Geduld
                  <div v-if="baseStore.isMobile" style="color: rgba(255,255,255,0.8); font-size: 18px; margin-top: 8px; margin-bottom: 32px;">
                 Das Webinar wird in Kürze gestartet
                </div>
                </div>
              
              </span>
              <v-btn 
                size="x-large" 
                color="#3d1b70" 
                variant="elevated"
                prepend-icon="mdi-play-circle"
                @click="startWebinar"
                style="min-width: 250px; font-size: 18px; font-weight: bold; box-shadow: 0 4px 20px rgba(76, 175, 80, 0.4);"
              >
                Webinar jetzt starten
              </v-btn>
            </div>
            
            <!-- Reaktions-Animation Overlay -->
            <transition name="reaction-fade">
              <div v-if="reactionAnimation.visible" 
                   style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; display: flex; align-items: center; justify-content: center; z-index: 100; pointer-events: none;">
                <v-icon 
                  :color="reactionAnimation.color" 
                  size="200"
                  class="reaction-pulse">
                  {{ reactionAnimation.icon }}
                </v-icon>
              </div>
            </transition>
            
            <!-- Audience Video - unten rechts als Overlay (auch ohne Präsentation) -->
            <div id="audience-video-inline-fullsize" 
                 :style="{
                   position: 'absolute',
                   bottom: '15px',
                   right: '15px',
                   width: '200px',
                   height: '150px',
                   background: '#000',
                   borderRadius: '0',
                   border: '2px solid #fff',
                   boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                   zIndex: 8,
                   display: showInlineVideoIdentity ? 'block' : 'none'
                 }">
            </div>
          </div>
          
          <!-- Wenn Präsentation gestartet: Slides als Hauptinhalt mit Admin Video als Overlay -->
          <template v-if="presentationStarted">
            <div class="audience-presentation-stage">
              <!-- Zentrale Slides (Vollgröße) -->
              <img
                v-if="activePictureBroadCast.type == 'picture'" 
                class="audience-presentation-media"
                :src="`/videos/webinar${slideShowNumber}/slides/${activePictureBroadCast.url}`"
              >
              
              <video
                v-show="activePictureBroadCast.type == 'video'" 
                ref="audienceVideoInline" 
                class="audience-presentation-media"
                :src="`/videos/webinar4/slides/${activePictureBroadCast.url}`" 
                controls 
                preload="auto"
              >
                Ihr Browser unterstützt das Video-Element nicht.
              </video>
              
              <!-- Versteckte Videos und Bilder zum Vorladen -->
              <div style="display: none;">
            <video v-if="currentWebinarSlides && currentWebinarSlides[1] && currentWebinarSlides[1].type === 'video'" 
                   :src="`/videos/webinar${slideShowNumber}/slides/${currentWebinarSlides[1].url}`" 
                       preload="auto"></video>
            <video v-if="activePictureBroadCast.type === 'video' && activePictureBroadCast.url !== (currentWebinarSlides[1] && currentWebinarSlides[1].url)" 
                       :src="`/videos/webinar${slideShowNumber}/slides/${activePictureBroadCast.url}`" 
                       preload="auto"></video>
                <video v-for="slide in getUpcomingVideoSlides()" :key="slide.url" :src="`/videos/webinar${slideShowNumber}/slides/${slide.url}`" preload="metadata"></video>
                <img v-for="slide in getUpcomingImageSlides()" :key="slide.url" :src="`/videos/webinar${slideShowNumber}/slides/${slide.url}`" />
            </div>
            
              <!-- Dozenten-Video läuft während der Präsentation neben den Folien (rechte Spalte bzw. mobil darunter) -->
              
              <!-- Audience Video - unten rechts als kleines Overlay (wenn showInlineVideoIdentity gesetzt) -->
              <div id="audience-video-inline" 
                   :style="{
                     position: 'absolute',
                     bottom: '15px',
                     right: '15px',
                     width: '200px',
                     height: '150px',
                     background: '#000',
                     borderRadius: '0',
                     border: '2px solid #fff',
                     boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                     zIndex: 8,
                     display: showInlineVideoIdentity ? 'block' : 'none'
                   }">
              </div>
              
              <!-- Reaktions-Animation Overlay -->
              <transition name="reaction-fade">
                <div v-if="reactionAnimation.visible" 
                     style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; display: flex; align-items: center; justify-content: center; z-index: 100; pointer-events: none;">
                  <v-icon 
                    :color="reactionAnimation.color" 
                    size="200"
                    class="reaction-pulse">
                    {{ reactionAnimation.icon }}
                  </v-icon>
                </div>
              </transition>
            </div>
          </template>
          
          <!-- Badges vertikal links oben (nur Desktop und wenn verbunden) -->
          <div v-if="isConnected && !baseStore.isMobile" style="position: absolute; top: 15px; left: 15px; z-index: 10; display: flex; flex-direction: column; gap: 10px;">
            <!-- Teilnehmer Badge -->
            <div v-if="allTeilnehmerInRoom && allTeilnehmerInRoom.length > 0" 
                  style="background: rgba(33, 150, 243, 0.9); border-radius: 0; padding: 8px 12px; display: flex; align-items: center; gap: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.3);">
              <v-icon color="white" size="24">mdi-account-group</v-icon>
              <span style="color: white; font-size: 20px; font-weight: bold;">{{ allTeilnehmerInRoom.length }}</span>
            </div>
            
            <!-- Fragen Badge -->
            <div v-if="webinarStats && webinarStats.fragen > 0" 
                  style="background: rgba(33, 150, 243, 0.9); border-radius: 0; padding: 8px 12px; display: flex; align-items: center; gap: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.3);">
              <v-icon color="white" size="24">mdi-help-circle</v-icon>
              <span style="color: white; font-size: 20px; font-weight: bold;">{{ webinarStats.fragen }}</span>
            </div>
            
            <!-- Danke Badge -->
            <div v-if="webinarStats && webinarStats.danke > 0" 
                  style="background: rgba(244, 67, 54, 0.9); border-radius: 0; padding: 8px 12px; display: flex; align-items: center; gap: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.3);">
              <v-icon color="white" size="24">mdi-heart</v-icon>
              <span style="color: white; font-size: 20px; font-weight: bold;">{{ webinarStats.danke }}</span>
            </div>
            
            <!-- Interessant Badge -->
            <div v-if="webinarStats && webinarStats.interessant > 0" 
                  style="background: rgba(255, 152, 0, 0.9); border-radius: 0; padding: 8px 12px; display: flex; align-items: center; gap: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.3);">
              <v-icon color="white" size="24">mdi-fire</v-icon>
              <span style="color: white; font-size: 20px; font-weight: bold;">{{ webinarStats.interessant }}</span>
            </div>
          </div>
          
          <!-- WTB Logo rechts oben (nur Desktop) -->
          <div v-if="!baseStore.isMobile" style="position: absolute; top: 15px; right: 20px; width: 40px; height: 80px; background: #3166a5; display: flex; align-items: flex-end; justify-content: center; padding-bottom: 4px; z-index: 10;">
            <span style="color: white; font-size: 14px; font-weight: bold;">WTB</span>
          </div>
        </div>
        
        </div>

        <!-- Dozent neben der Präsentation (Container-ID wird von attachVideoTrack/Präsentations-Watcher genutzt) -->
      <div v-if="presentationStarted && baseStore.isMobile" class="dozent-side-video mt-2">
        <div v-show="hasAdminVideo" id="admin-videos-inline" class="dozent-side-video__stage"></div>
        <div v-if="!hasAdminVideo" class="dozent-side-video__stage dozent-side-video__placeholder">
          <v-icon size="40" color="white">mdi-video-off</v-icon>
        </div>
        <div class="dozent-side-video__label">
          <span class="dozent-side-video__live" v-if="hasAdminVideo">LIVE</span>
          {{ terminData.dozent }}
        </div>
      </div>

        <!-- Badges für Mobile (horizontal als Chips) -->
        <v-row v-if="isConnected && baseStore.isMobile" dense class="mt-2 mb-2" justify="center">
          <v-col cols="auto" v-if="allTeilnehmerInRoom && allTeilnehmerInRoom.length > 0">
            <v-chip color="blue" variant="elevated">
              <v-icon start size="small">mdi-account-group</v-icon>
              {{ allTeilnehmerInRoom.length }}
            </v-chip>
          </v-col>
          <v-col cols="auto" v-if="webinarStats && webinarStats.fragen > 0">
            <v-chip color="blue" variant="elevated">
              <v-icon start size="small">mdi-help-circle</v-icon>
              {{ webinarStats.fragen }}
            </v-chip>
          </v-col>
          <v-col cols="auto" v-if="webinarStats && webinarStats.danke > 0">
            <v-chip color="white" variant="elevated" style="border: 2px solid #F44336;">
              <v-icon start size="small" color="#F44336">mdi-heart</v-icon>
              <span style="color: #333;">{{ webinarStats.danke }}</span>
            </v-chip>
          </v-col>
          <v-col cols="auto" v-if="webinarStats && webinarStats.interessant > 0">
            <v-chip color="orange" variant="elevated">
              <v-icon start size="small">mdi-fire</v-icon>
              {{ webinarStats.interessant }}
            </v-chip>
          </v-col>
        </v-row>
        
        <!-- Reaktions-Button-Leiste -->
        <v-row v-if="isConnected" class="audience-reactions-row">
          <v-col cols="12">
            <div class="audience-reactions-card">
              <div class="audience-reaction-buttons">
                <v-btn
                  class="audience-reaction-btn audience-reaction-btn--frage"
                  color="#3d1b70"
                  variant="elevated"
                  size="large"
                  prepend-icon="mdi-comment-question"
                  @click="focusQuestionInput"
                >
                  Frage stellen
                </v-btn>

                <v-btn
                  class="audience-reaction-btn"
                  color="blue"
                  variant="elevated"
                  size="large"
                  prepend-icon="mdi-human-greeting"
                  @click="sendReaction('userHallo')"
                >
                  Hallo
                </v-btn>

                <v-btn
                  class="audience-reaction-btn"
                  variant="elevated"
                  size="large"
                  @click="sendReaction('userDanke')"
                  style="background: white; color: #333; font-weight: bold;"
                >
                  <v-icon color="#F44336" class="mr-2">mdi-heart</v-icon>
                  Danke
                </v-btn>

                <v-btn
                  class="audience-reaction-btn"
                  color="orange"
                  variant="elevated"
                  size="large"
                  prepend-icon="mdi-fire"
                  @click="sendReaction('userInteressant')"
                >
                  Interessant
                </v-btn>
              </div>

              <div v-if="terminData.wteil_copilot == 1" class="audience-reaction-copilot">
                <v-btn
                  variant="elevated"
                  size="large"
                  @click="sendReactionPilot('showDankeDialog')"
                  block
                  style="font-weight: bold; background: white; color: #333;"
                >
                  <v-icon color="#F44336" class="mr-2">mdi-heart</v-icon>
                  Danke Dialog für alle User einblenden
                </v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
        
        <v-row justify="center">
          <v-col cols="12" md="10">
        
          <!-- Mein Broadcast Bereich (nur Mobile) -->
          <div v-if="baseStore.isMobile && isMyBroadcasting" class="mb-4">
            <!-- Audio-Only: Zeige nur Audio-Indikator -->
            <div v-if="audioOnlyBroadcast" id="mein-broadcast-mobile" style="width: 100%; min-height: 200px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); border-radius: 0; margin-bottom: 20px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
              <v-icon size="80" color="white" class="mb-4">mdi-microphone</v-icon>
              <div style="color: white; font-size: 24px; font-weight: bold;">Audio Live</div>
            </div>
            <!-- Video + Audio: Zeige Video-Container -->
            <div v-else id="mein-broadcast-mobile" style="width: 100%; min-height: 200px; background: #000; border-radius: 0; margin-bottom: 20px;"></div>
            
            <v-card class="mb-4" color="success" variant="tonal">
              <v-card-text>
                <div class="d-flex align-center justify-space-between mb-3">
                  <div class="d-flex align-center">
                    <v-icon color="success" class="mr-2">mdi-broadcast</v-icon>
                    <span class="text-h6">Sie sind "on Air"</span>
                  </div>
                </div>
                <div class="d-flex gap-2 mb-3">
                  <v-chip v-if="localVideoTrack" color="success" size="small">
                    <v-icon start size="small">mdi-video</v-icon>
                    Video
                  </v-chip>
                  <v-chip v-if="localAudioTrack" color="success" size="small">
                    <v-icon start size="small">mdi-microphone</v-icon>
                    Audio
                  </v-chip>
                </div>
                <v-btn 
                  color="red" 
                  variant="elevated" 
                  block
                  prepend-icon="mdi-stop-circle"
                  @click="stopMyBroadcast"
                  size="large"
                >
                  Übertragung beenden
                </v-btn>
              </v-card-text>
            </v-card>
          </div>
          <div v-else-if="baseStore.isMobile" id="mein-broadcast-mobile" style="display: none;"></div>
        
          <!-- Nur Audience Teilnehmer (nicht Admin, nicht ich selbst) -->
      
       
  
    
       
        <!-- <div v-if="audienceParticipants.length === 0" style="padding: 20px; background: #d1ecf1; border-radius: 8px;">
          <p>ℹ️ Keine anderen Teilnehmer im Room</p>
         </div> -->
          </v-col>
        
        </v-row>

         
          
          <div v-if="showDebug">
          <h2>Teilnehmer ({{ allTeilnehmerInRoom.length }})</h2>
          <div style="max-height: 300px; overflow-y: auto; background: #fff; padding: 8px; border: 1px solid #ddd; margin-bottom: 20px;">
            <div v-if="allTeilnehmerInRoom.length === 0" style="padding: 8px; color: #666;">Keine Teilnehmer</div>
            <div v-else>
              <div v-for="(p, idx) in allTeilnehmerInRoom" :key="idx" style="padding: 8px; border-bottom: 1px solid #eee; display: flex; justify-content: space-between; align-items: center;">
                <div>
                  <div style="font-weight: bold; color: #333;">
                    {{ p.identity }}
                    <span v-if="p.identity === myIdentity" style="color: #007bff; font-size: 12px;">(Ich)</span>
                    <span v-if="p.identity.startsWith('admin_')" style="color: #dc3545; font-size: 12px;">(Admin)</span>
            </div>
                  <div style="font-size: 12px; color: #666;">
                    📹 Video: {{ p.videoTracks }} | 🎤 Audio: {{ p.audioTracks }} | 💬 Data: {{ p.dataTracks }}
              </div>
            </div>
                <div>
                  <span v-if="p.videoTracks > 0 || p.audioTracks > 0" style="background: #28a745; color: white; padding: 2px 8px; border-radius: 0; font-size: 11px;">Broadcasting</span>
                  <span v-else style="background: #6c757d; color: white; padding: 2px 8px; border-radius: 0; font-size: 11px;">Watching</span>
             </div>
    </div>
     </div>
    </div>
    </div>

<div v-if="showDebug">
          <h2>Datatrack Nachrichten</h2>
          <div v-if="dataTrackMessages.length === 0" style="padding: 8px; color: #666;">Noch keine Nachrichten</div>
          <div v-else style="max-height: 400px; overflow-y: auto; background: #f8f9fa; padding: 8px; border: 1px solid #ddd;">
            <div v-for="(msg, idx) in dataTrackMessages" :key="idx" style="padding: 6px 8px; border-bottom: 1px solid #eee;">
              <div style="font-weight: bold; color: #333;">{{ msg.from }} <span style="font-weight: normal; color: #999;">{{ new Date(msg.ts).toLocaleTimeString() }}</span></div>
              <div v-if="msg.payload && msg.payload.type" style="font-size: 12px; color: #999;">{{ msg.payload.type }}</div>
              <div v-if="msg.payload && msg.payload.text">{{ msg.payload.text }}</div>
              <pre v-else style="white-space: pre-wrap; word-break: break-word; margin: 6px 0 0 0;">{{ msg.payload }}</pre>
            </div>
  </div> 
</div>

  </v-col>

  <!-- Rechte Spalte: Fragen an den Dozenten (Desktop daneben, Mobil direkt unter dem Video) -->
  <v-col cols="12" md="4">
    <div class="audience-side-column">

      <!-- Dozent neben der Präsentation (Container-ID wird von attachVideoTrack/Präsentations-Watcher genutzt) -->
      <div v-if="presentationStarted && !baseStore.isMobile" class="dozent-side-video">
        <div v-show="hasAdminVideo" id="admin-videos-inline" class="dozent-side-video__stage"></div>
        <div v-if="!hasAdminVideo" class="dozent-side-video__stage dozent-side-video__placeholder">
          <v-icon size="40" color="white">mdi-video-off</v-icon>
        </div>
        <div class="dozent-side-video__label">
          <span class="dozent-side-video__live" v-if="hasAdminVideo">LIVE</span>
          {{ terminData.dozent }}
        </div>
      </div>

      <!-- Fragen-Panel: Hauptinteraktion der Audience -->
      <div ref="questionPanel" class="question-panel">
        <div class="question-panel__head">
          <v-icon size="32" color="white" class="mr-3">mdi-comment-question</v-icon>
          <div>
            <div class="question-panel__title">Ihre Frage an {{ terminData.dozent || 'den Dozenten' }}</div>
            <div class="question-panel__subtitle">
              <span v-if="hasAdminVideo || hasAdminAudio">Ihre Frage erscheint sofort beim Dozenten.</span>
              <span v-else>Sie können Ihre Frage schon jetzt stellen.</span>
            </div>
          </div>
        </div>

        <div class="question-panel__body">
          <v-alert
            v-if="terminData.beendet"
            type="info"
            variant="tonal"
            density="compact"
          >
            Das Webinar ist beendet – es können keine Fragen mehr gestellt werden.
          </v-alert>

          <template v-else>
            <v-textarea
              ref="questionInputRef"
              v-model="questionInput"
              placeholder="Was möchten Sie wissen?"
              variant="outlined"
              bg-color="white"
              rows="3"
              auto-grow
              :counter="QUESTION_MAX_LENGTH"
              :maxlength="QUESTION_MAX_LENGTH"
              :disabled="!canAskQuestions"
              hide-details="auto"
              @keydown.enter.exact.prevent="submitQuestion"
            />
            <div class="question-panel__actions">
              <span class="text-caption text-medium-emphasis">Enter = senden · Shift+Enter = neue Zeile</span>
              <v-btn
                color="#3d1b70"
                size="large"
                prepend-icon="mdi-send"
                :loading="questionSending"
                :disabled="!canSubmitQuestion"
                @click="submitQuestion"
              >
                Frage senden
              </v-btn>
            </div>

            <v-alert
              v-if="questionNotice"
              type="success"
              variant="tonal"
              density="compact"
              class="mt-3"
            >
              Danke! Ihre Frage ist beim Dozenten angekommen.
            </v-alert>
            <v-alert
              v-if="questionError"
              type="error"
              variant="tonal"
              density="compact"
              class="mt-3"
            >
              {{ questionError }}
            </v-alert>
          </template>
        </div>

        <!-- Fragen im Webinar (neueste oben) -->
        <div class="question-feed" :class="{ 'question-feed--compact': presentationStarted && !baseStore.isMobile }">
          <div class="question-feed__head">
            <span>Fragen im Webinar ({{ participantQuestionCount }})</span>
            <v-btn-toggle
              v-if="myQuestionCount > 0"
              v-model="questionFilter"
              density="compact"
              variant="outlined"
              mandatory
              color="#3d1b70"
            >
              <v-btn value="all" size="small">Alle</v-btn>
              <v-btn value="mine" size="small">Meine ({{ myQuestionCount }})</v-btn>
            </v-btn-toggle>
          </div>

          <div v-if="questionFeed.length === 0" class="question-feed__empty">
            Noch keine Fragen – stellen Sie gerne die erste!
          </div>

          <div
            v-for="item in questionFeed"
            :key="item.key"
            class="question-item"
            :class="{
              'question-item--mine': item.mine,
              'question-item--answered': item.answered,
              'question-item--team': item.team
            }"
          >
            <div class="question-item__text">{{ item.text }}</div>
            <div class="question-item__meta">
              <span>
                <v-icon v-if="item.team" size="14" class="mr-1">mdi-account-tie</v-icon>
                <b>{{ item.mine ? 'Ich' : item.name }}</b> · {{ formatTime(item.ts) }}
              </span>
              <v-chip
                v-if="item.answered"
                size="x-small"
                color="green"
                variant="flat"
                prepend-icon="mdi-check"
              >
                beantwortet
              </v-chip>
              <v-chip
                v-else-if="item.mine"
                size="x-small"
                color="#3d1b70"
                variant="tonal"
              >
                offen
              </v-chip>
            </div>
          </div>
        </div>
      </div>

      <!-- Live zugeschaltete Teilnehmer (deaktiviert, siehe AUDIENCE_LIVE_ENABLED) -->
      <template v-if="AUDIENCE_LIVE_ENABLED">
        <div v-for="participant in audienceParticipants" :key="participant.identity" v-show="hasVideo(participant.identity) || hasAudio(participant.identity)" style="margin-bottom: 20px;">
          <!-- Audio-Only Mode: Zeige Sprecher-Indikator -->
          <div v-if="!hasVideo(participant.identity) && hasAudio(participant.identity)" style="padding: 20px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); border-radius: 0; text-align: center;">
            <v-icon size="60" color="white" class="mb-3 pulse-animation">mdi-account-voice</v-icon>
            <div style="color: white; font-size: 24px; font-weight: bold;">{{ getNameFromTeilnehmer(participant.identity, 'name') }}</div>
            <div style="color: rgba(255,255,255,0.8); font-size: 14px; margin-top: 8px;">spricht gerade</div>
          </div>
          <!-- Video Mode: Zeige Video-Container mit Name-Overlay -->
          <div v-else :id="`video-container-${participant.identity.replace('_', '-')}`" style="padding: 10px; background: #fff; border-radius: 0; border: 1px solid #ddd; position: relative;">
            <div class="video-area" v-if="showInlineVideoIdentity !== participant.identity" style="width: 100%; height: 300px; background: #000; border-radius: 0; position: relative;">
              <div style="position: absolute; bottom: 0; left: 0; right: 0; background: linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 100%); padding: 12px; z-index: 10;">
                <div style="color: white; font-size: 18px; font-weight: bold; text-shadow: 2px 2px 4px rgba(0,0,0,0.8);">
                  {{ getNameFromTeilnehmer(participant.identity, 'name') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <!-- Mein Broadcast Bereich (Desktop, nur bei AUDIENCE_LIVE_ENABLED) -->
      <div v-if="isMyBroadcasting && !baseStore.isMobile" class="mb-4 mt-4">
        <div v-if="audioOnlyBroadcast" id="mein-broadcast" style="width: 100%; min-height: 200px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); border-radius: 0; margin-bottom: 20px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
          <v-icon size="80" color="white" class="mb-4">mdi-microphone</v-icon>
          <div style="color: white; font-size: 24px; font-weight: bold;">Audio Live</div>
        </div>
        <div v-else id="mein-broadcast" style="width: 100%; min-height: 200px; background: #000; border-radius: 0; margin-bottom: 20px;"></div>
        <v-card class="mb-4" color="success" variant="tonal">
          <v-card-text>
            <div class="d-flex align-center justify-space-between">
              <div class="d-flex align-center">
                <v-icon color="success" class="mr-2">mdi-broadcast</v-icon>
                <span class="text-h6">Sie sind "on Air"</span>
              </div>
              <div class="d-flex gap-2">
                <v-chip v-if="localVideoTrack" color="success" size="small">
                  <v-icon start size="small">mdi-video</v-icon>
                  Video
                </v-chip>
                <v-chip v-if="localAudioTrack" color="success" size="small">
                  <v-icon start size="small">mdi-microphone</v-icon>
                  Audio
                </v-chip>
              </div>
            </div>
            <v-btn color="red" variant="elevated" block prepend-icon="mdi-stop-circle" @click="stopMyBroadcast" size="large" class="mt-3">
              Übertragung beenden
            </v-btn>
          </v-card-text>
        </v-card>
      </div>
      <div v-else-if="!baseStore.isMobile" id="mein-broadcast" style="display: none;"></div>

      <div v-if="isConnected && publicDataTrackMessages.length > 0" class="activity-panel mt-4">
        <h3 class="mb-2" style="color: #3d1b70;">Aktivitäten</h3>
        <div style="max-height: 250px; overflow-y: auto;">
          <div
            v-for="(msg, idx) in publicDataTrackMessages"
            :key="idx"
            class="activity-message"
          >
            <template v-if="msg.type === 'newTeilnehmerRegistered'">
              <v-icon color="green" size="20">mdi-account-plus</v-icon>
              <span>jetzt auch dabei: <b>{{ getNameFromTeilnehmer(msg.from,'name') }}</b></span>
            </template>
            <template v-if="msg.type === 'jetzLiveImWebinar'">
              <v-icon color="green" size="20">mdi-camera</v-icon>
              <span>jetzt live: <b>{{ getNameFromTeilnehmer(msg.from,'name') }}</b></span>
            </template>
            <template v-if="msg.type === 'userDanke'">
              <v-icon color="red" size="20">mdi-heart</v-icon>
              <span><b>{{ getNameFromTeilnehmer(msg.from,'name') }}</b> sagt Danke</span>
            </template>
            <template v-if="msg.type === 'userInteressant'">
              <v-icon color="orange" size="20">mdi-fire</v-icon>
              <span><b>{{ getNameFromTeilnehmer(msg.from,'name') }}</b> findet es interessant</span>
            </template>
            <template v-if="msg.type === 'neueUserFragen'">
              <v-icon color="blue" size="20">mdi-help-circle</v-icon>
              <span><b>{{ getNameFromTeilnehmer(msg.from,'name') }}</b> stellt eine Frage</span>
            </template>
            <template v-if="msg.type === 'userHallo'">
              <v-icon color="blue" size="20">mdi-human-greeting</v-icon>
              <span><b>{{ getNameFromTeilnehmer(msg.from,'name') }}</b> sagt Hallo</span>
            </template>
          </div>
        </div>
      </div>

      <div class="audio-test-banner my-4">
        <div class="font-weight-medium mb-2">Kein Ton?</div>
        <div class="d-flex flex-wrap gap-2 mb-2">
          <v-btn
            size="small"
            color="primary"
            variant="tonal"
            :loading="isSpeakerTesting"
            @click="testSpeakerOutput"
          >
            Lautsprecher testen
          </v-btn>
          <v-btn
            v-if="AUDIENCE_LIVE_ENABLED"
            size="small"
            color="primary"
            variant="tonal"
            :loading="isMicrophoneTesting"
            @click="testMicrophoneInput"
          >
            Mikro testen
          </v-btn>
        </div>
        <div class="text-caption text-medium-emphasis">
          Lautsprecher: <b>{{ audioTestStatus.speaker }}</b>
          <span v-if="AUDIENCE_LIVE_ENABLED"> · Mikro: <b>{{ audioTestStatus.microphone }}</b></span>
        </div>
      </div>
    </div>
  </v-col>

</v-row>
  <v-dialog v-model="showDankeDialog" width="666" >
    <v-card class="pa-4">
      <v-row>
        <v-col cols="12" class="pl-4">
          <h2>Hat Ihnen das Webinar gefallen?</h2>
          <p>Wir freuen uns über Ihre Meinung bzw. ein kleines Danke. </p><br /><br />
          <v-textarea rows="3" v-model="dankeText" label="Ihre Meinung ist uns wichtig" bg-color="white" />
          <v-btn width="100%" color="primary" @click="sendDanke">jetzt Feedback speichern</v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
  </v-container>
</template>

<script setup>
import { inject, ref, onMounted, onBeforeUnmount, markRaw, watch, shallowRef, nextTick, computed } from "vue";
const Video = require('twilio-video');
import { storeToRefs } from 'pinia';
import { useRoute, useRouter } from "vue-router";
import { useUserStore } from '@/stores/userStore';
import { useWebinarStore } from '@/stores/webinarStore';
import { AUDIENCE_LIVE_ENABLED } from '@/services/webinarFeatures';

const baseCalls = inject('baseCalls');
const successStore = inject('successStore');
const updateDocumentHead = inject('updateDocumentHead');
const loaderStore = inject('loaderStore');
const baseStore = inject('baseStore')

const userStore = useUserStore();
const { userToken, userWebinarTerminId } = storeToRefs(userStore);
const webinarStore = useWebinarStore();
const route = useRoute();
const router = useRouter();



// Generate unique browser token (UUID v4)
function generateUUID() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  // Fallback for older browsers
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

// BrowserToken aus URL holen oder neu generieren
function initBrowserToken() {
  // 1. Prüfe ob browserToken in URL vorhanden ist (Path-Parameter)
  const btFromUrl = route.params.browserToken;
  if (btFromUrl && typeof btFromUrl === 'string' && btFromUrl.length > 0) {
    console.log('✅ BrowserToken aus URL geladen:', btFromUrl);
    return btFromUrl;
  }
  
  // 2. Kein Token in URL → generiere neuen
  const newToken = generateUUID();
  console.log('🆕 Neuer BrowserToken generiert:', newToken);
  return newToken;
}

// Basis-Refs
const room = shallowRef(null);
const audioOnlyBroadcast = ref(false);
const isConnected = ref(false);
const isConnecting = ref(false);
const browserToken = ref(initBrowserToken());
//const hasStartedSession = ref(false);
const token = ref('');
const webinarTerminId = ref(false);
const showDankeDialog = ref(false);
const autoConnectLoading = ref(false);
const autoConnectMessage = ref('');
const autoConnectAttempts = ref(0);
const autoConnectTimer = ref(null);
const showAutoConnectLoader = ref(true);
const showBrowserTokenConflict = ref(false);
const showAudienceOverbookedError = ref(false);
const audioPlaybackBlocked = ref(false);
const pendingAudioElements = new Set();
let audioUnlockHandler = null;
const audioTestStatus = ref({
  speaker: 'ungetestet',
  microphone: 'ungetestet'
});
const isSpeakerTesting = ref(false);
const isMicrophoneTesting = ref(false);

const terminData = ref({
  open: false,
  beendet: false,
  wter_id: null,
  id: null
});

// Teilnehmer-Tracking
const showInlineVideoIdentity = ref(null); // Welches Audience-Video soll im Admin-Container angezeigt werden?
const allTeilnehmerInRoom = ref([]);
const localDataTrack = shallowRef(null);
const localVideoTrack = shallowRef(null);
const localAudioTrack = shallowRef(null);
const isMyBroadcasting = ref(false);
const myIdentity = computed(() => `audience_${route.params.teilnahmeid}`);
const audienceIdentityHasVideo = ref({}); // identity -> boolean
const audienceIdentityHasAudio = ref({}); // identity -> boolean (für Audio-Only)
const hasAdminVideo = ref(false); // Admin sendet Video?
const hasAdminAudio = ref(false); // Admin sendet Audio?
const dataTrackMessages = ref([]); // eingehende DataTrack Nachrichten
const publicDataTrackMessages = ref([]); // eingehende Public Track Nachrichten
// Fragen an den Dozenten
const QUESTION_MAX_LENGTH = 500;
const QUESTION_POLL_MS = 30000;
const QUESTION_STATUS_ANSWERED = 3;
const questions = ref([]); // aus wtb_webinar_fragen (Quelle der Wahrheit inkl. Status)
const teamMessages = ref([]); // Dozent/Admin-Nachrichten live per DataTrack, bis sie aus der DB nachgeladen sind
const questionInput = ref('');
const questionSending = ref(false);
const questionNotice = ref(false);
const questionError = ref('');
const questionFilter = ref('all');
const questionPanel = ref(null);
const questionInputRef = ref(null);
let questionPollTimer = null;
let questionReloadTimer = null;
let questionNoticeTimer = null;
// Präsentations-Refs
// slideShowNumber entspricht der webi_id aus wtb_webinar Tabelle
// Bestimmt den Ordner: /videos/webinar<slideShowNumber>/slides/
const slideShowNumber = ref(5); // Webinar Nummer (wird aus terminData.wter_webinar_id gesetzt)
const presentationStarted = ref(false);
const presentationView = ref('inline'); // 'inline' oder 'standard'
const audienceVideoInline = ref(null);
const showDebug = ref(false);

const webinarStats = ref({
  fragen: 0,
  danke: 0,
  interessant: 0,
});

function resolveDozentImage(imageName) {
  if (!imageName) return null;
  if (typeof imageName !== 'string' || imageName.length === 0) return null;
  if (imageName.startsWith('/')) return imageName;

  try {
    return require(`@/assets/dozenten/${imageName}`);
  } catch (e) {
    // Fallback: Public-Pfad (falls Asset lokal nicht vorhanden ist)
    return `/dozenten/${imageName}`;
  }
}

// Dozentenbild aus terminData (lokal bevorzugt aus @/assets/dozenten/)
const dozentImageSrc = computed(() => {
  try {
    if (!terminData.value || !terminData.value.dozent_image) return null;
    const img = terminData.value.dozent_image;
    return resolveDozentImage(img);
  } catch (e) {
    console.warn('Fehler beim Ermitteln des Dozentenbildes:', e);
    return null;
  }
});

const startButtonPressed = ref(false);
// Reaktions-Animation über Admin-Video
const reactionAnimation = ref({
  visible: false,
  icon: '',
  color: ''
});

// Slides für aktuelles Webinar
const currentWebinarSlides = computed(() => {
  return webinarStore.pictureBroadCast && webinarStore.pictureBroadCast[slideShowNumber.value] 
    ? webinarStore.pictureBroadCast[slideShowNumber.value] 
    : {};
});

const activePictureBroadCast = ref({
  url: currentWebinarSlides.value && currentWebinarSlides.value[1] ? currentWebinarSlides.value[1].url : '',
  type: currentWebinarSlides.value && currentWebinarSlides.value[1] ? currentWebinarSlides.value[1].type : 'picture'
});


const audience = ref([]);

const dankeText = ref('');
const dankeSent = ref(false);

async function sendDanke() {
  let data = {
    action: 'sendDanke',
    danke_text: dankeText.value,
    danke_wteil_id: route.params.teilnahmeid,
    danke_wter_id: userWebinarTerminId.value,
    danke_webi_id: terminData.value.webi_id,
  }
  console.log('sendDanke', data);
  loaderStore.setLoader(true, "Ihre Meinung wird gesendet...");
  const response = await baseCalls.webinarPost(data);
  if (response.data.success == true) {
    dankeText.value = '';
    dankeSent.value = true;
    loaderStore.setLoader(false);
    successStore.setSuccess(true, 'Ihre Meinung wurde gespeichert', 'Danke für Ihre Meinung');
    sendDataMessage({ type: 'userDanke',from: myIdentity.value,ts: Date.now() });
    showDankeDialog.value = false;
  }
}

async function testSpeakerOutput() {
  if (isSpeakerTesting.value) return;
  isSpeakerTesting.value = true;
  audioTestStatus.value.speaker = 'läuft...';
  try {
    const AudioCtx = window.AudioContext || window.webkitAudioContext;
    if (!AudioCtx) {
      audioTestStatus.value.speaker = 'nicht unterstützt';
      return;
    }
    const ctx = new AudioCtx();
    await ctx.resume();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = 'sine';
    osc.frequency.value = 440;
    gain.gain.value = 0.15;
    osc.connect(gain).connect(ctx.destination);
    osc.start();
    await new Promise(resolve => setTimeout(resolve, 700));
    osc.stop();
    osc.disconnect();
    gain.disconnect();
    await ctx.close();
    audioTestStatus.value.speaker = 'ok';
  } catch (error) {
    console.warn('Speaker test failed', error);
    audioTestStatus.value.speaker = 'fehlgeschlagen';
  } finally {
    isSpeakerTesting.value = false;
  }
}

async function testMicrophoneInput() {
  if (isMicrophoneTesting.value) return;
  isMicrophoneTesting.value = true;
  audioTestStatus.value.microphone = 'läuft...';
  try {
    if (!navigator.mediaDevices?.getUserMedia) {
      audioTestStatus.value.microphone = 'nicht unterstützt';
      return;
    }
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    stream.getTracks().forEach(track => track.stop());
    audioTestStatus.value.microphone = 'ok';
  } catch (error) {
    console.warn('Microphone test failed', error);
    audioTestStatus.value.microphone = 'fehlgeschlagen';
  } finally {
    isMicrophoneTesting.value = false;
  }
}

const myTeilnahmeId = computed(() => String(route.params.teilnahmeid));

const canAskQuestions = computed(() => !!terminData.value?.wter_id && !terminData.value?.beendet);
const canSubmitQuestion = computed(() => canAskQuestions.value && !questionSending.value && questionInput.value.trim().length > 0);
const myQuestionCount = computed(() => questions.value.filter(q => q.mine).length);
const participantQuestionCount = computed(() => questions.value.filter(q => !q.team).length);

// Fragen + Antworten vom Team, neueste oben
const questionFeed = computed(() => {
  const own = questionFilter.value === 'mine';
  const items = questions.value
    .filter(q => !own || q.mine)
    .map(q => ({ ...q, key: 'q' + q.id }));
  if (!own) {
    teamMessages.value.forEach((m, idx) => items.push({ ...m, key: 't' + idx }));
  }
  return items.sort((a, b) => b.ts - a.ts);
});

function focusQuestionInput() {
  const panel = questionPanel.value;
  if (panel && typeof panel.scrollIntoView === 'function') {
    panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  nextTick(() => questionInputRef.value?.focus?.());
}

async function submitQuestion() {
  const text = questionInput.value.trim().slice(0, QUESTION_MAX_LENGTH);
  if (!text || !canSubmitQuestion.value) return;

  questionSending.value = true;
  questionError.value = '';
  try {
    const response = await baseCalls.webinarPost({
      action: 'saveFrage',
      frage: text,
      terminid: terminData.value.wter_id,
      teilnehmerid: route.params.teilnahmeid,
    });
    if (response?.data?.success !== true) {
      throw new Error('saveFrage ohne success');
    }

    questionInput.value = '';
    showReactionAnimation('frage');
    showQuestionNotice();

    // Erst nach dem Speichern benachrichtigen, damit Dozent/Admin die Frage beim Nachladen schon finden
    sendDataMessage({ type: 'chatMessage', from: myIdentity.value, text, timestamp: Date.now() });
    sendDataMessage({ type: 'neueUserFragen', from: myIdentity.value, timestamp: Date.now() });
    setTimeout(() => {
      sendDataMessage({ type: 'neueFragen', identity: myIdentity.value, ts: Date.now() });
    }, 150);

    await loadQuestions();
    getWebinarStats();
  } catch (error) {
    console.error('Frage konnte nicht gespeichert werden:', error);
    questionError.value = 'Ihre Frage konnte nicht gesendet werden. Bitte versuchen Sie es noch einmal.';
  } finally {
    questionSending.value = false;
  }
}

function showQuestionNotice() {
  questionNotice.value = true;
  clearTimeout(questionNoticeTimer);
  questionNoticeTimer = setTimeout(() => { questionNotice.value = false; }, 5000);
}

// Fragen des Termins aus wtb_webinar_fragen laden (inkl. Status "beantwortet")
async function loadQuestions() {
  if (!terminData.value?.wter_id) return;
  try {
    const response = await baseCalls.webinarPost({
      action: 'getFragen',
      id: terminData.value.wter_id,
    });
    if (response?.data?.success !== true) return;

    const known = new Map(questions.value.map(q => [q.id, q]));
    const now = Date.now();
    questions.value = (response.data.fragen || [])
      .filter(item => item && item.frage)
      .map(item => {
        const team = !!item.team;
        const live = team ? teamMessages.value.find(m => m.text === item.frage) : null;
        return {
          id: item.id,
          text: item.frage,
          name: item.name,
          team,
          mine: !team && String(item.teilnehmerid) === myTeilnahmeId.value,
          answered: !team && Number(item.status) === QUESTION_STATUS_ANSWERED,
          // Zeitstempel beim ersten Laden fixieren, sonst springt die Sortierung bei jedem Poll
          ts: known.get(item.id)?.ts ?? live?.ts ?? (now - (item.vor || 0) * 60 * 1000),
        };
      });

    // Live empfangene Antworten, die jetzt aus der DB kommen, nicht doppelt zeigen
    teamMessages.value = teamMessages.value.filter(
      m => !questions.value.some(q => q.team && q.text === m.text)
    );
  } catch (error) {
    console.error('Fehler beim Laden der Fragen:', error);
  }
}

// Viele Teilnehmer melden gleichzeitig neue Fragen → Nachladen bündeln
function scheduleQuestionReload() {
  clearTimeout(questionReloadTimer);
  questionReloadTimer = setTimeout(loadQuestions, 1000);
}

function startQuestionPolling() {
  if (questionPollTimer) return;
  questionPollTimer = setInterval(loadQuestions, QUESTION_POLL_MS);
}

function stopQuestionPolling() {
  clearInterval(questionPollTimer);
  questionPollTimer = null;
  clearTimeout(questionReloadTimer);
  clearTimeout(questionNoticeTimer);
}

// Chat-Nachrichten vom Dozenten sofort als Antwort zeigen (gespeichert werden sie vom
// Dozenten selbst per saveFrage). Alles andere kommt über loadQuestions aus der DB.
function addTeamMessageFromPayload(payload, fromIdentity) {
  if (!payload || !payload.text) return;
  const from = payload.from || fromIdentity || '';
  if (!from.startsWith('admin_')) {
    scheduleQuestionReload();
    return;
  }
  teamMessages.value.push({
    text: payload.text,
    name: getNameFromTeilnehmer(from, 'name'),
    team: true,
    mine: false,
    answered: false,
    ts: payload.timestamp || payload.ts || Date.now(),
  });
  // Dozent speichert parallel zum Senden → kurz danach aus der DB übernehmen
  scheduleQuestionReload();
}

const isOpen = computed(() => {
  if(!terminData.value || !terminData.value.wter_beginn){
    return false;
  }
  if (terminData.value.beendet == 1) {
    return false;
  }
  if (terminData.value.open == false) {
    return false;
  }
    // Parse the wter_beginn string into a Date object
    const wterBeginnDate = new Date(terminData.value.wter_beginn);

    // Get the current time
    const now = new Date();

    // Calculate the start and end of the range
    const startRange = new Date(wterBeginnDate);
    startRange.setMinutes(startRange.getMinutes() - 10);

    const endRange = new Date(wterBeginnDate);
    endRange.setMinutes(endRange.getMinutes() + 180);
    console.log(now > startRange && now < endRange);
    // Check if the current time is within the range
    return true;

    //return now > startRange && now < endRange;
});
// Nur Audience-Teilnehmer (nicht Admin, nicht ich selbst)
const audienceParticipants = computed(() => {
  const myIdentity = `audience_${route.params.teilnahmeid}`;
  return allTeilnehmerInRoom.value.filter(p => 
    p.identity.startsWith('audience_') && 
    p.identity !== myIdentity &&
    !p.identity.startsWith('admin_')
  );
});

async function startWebinar() {
  startButtonPressed.value = true;
  
  // Sicherstellen, dass browserToken aus URL in DB gespeichert wird
  try {
    const data = {
      action: 'saveBrowserToken',
      id: route.params.teilnahmeid,
      hash: route.params.hash,
      browserToken: browserToken.value,
    };
    const response = await baseCalls.webinarPost(data);
    if (response.data.success) {
      console.log('✅ BrowserToken aus URL gespeichert:', browserToken.value);
    } else {
      console.warn('⚠️ BrowserToken konnte nicht gespeichert werden:', response.data.message);
    }
  } catch (error) {
    console.warn('⚠️ BrowserToken-Speichern fehlgeschlagen:', error);
  }
  
  // Bei manuellem Start: browserToken-Check überspringen und neuen Token forcieren
  await startSession({ 
    forceTokenRefresh: true, 
    showLoader: true,
    skipBrowserTokenCheck: true 
  });
}

async function getToken() {
  console.log('getToken');
  if (!isOpen.value) {
    console.log('Webinar ist nicht offen');
    return false;
  }

  showAudienceOverbookedError.value = false;

  const data = {
    action: 'getWebinarAudienceUserToken',
    id: route.params.teilnahmeid,
    hash: route.params.hash,
    admin: 0,
    browserToken: browserToken.value,
  };

  try {
    const response = await baseCalls.webinarPost(data);
    if (response.data.success === true) {
      token.value = response.data.token;
      userStore.setToken(response.data.token);
      userStore.setWebinarTerminId(response.data.terminId);
      webinarTerminId.value = response.data.terminId;
      showAudienceOverbookedError.value = false;
      console.log('✅ Token erfolgreich geholt');
      return true;
    }
    if ((response?.data?.message || '').includes('Maximal 48 Teilnehmer')) {
      showAudienceOverbookedError.value = true;
    }
    console.error('❌ Token konnte nicht geholt werden');
    return false;
  } catch (error) {
    console.error('❌ Fehler beim Token holen:', error);
    return false;
  }
}

async function ensureToken({ force = false } = {}) {
  if (!force && userToken.value && userWebinarTerminId.value) {
    token.value = userToken.value;
    webinarTerminId.value = userWebinarTerminId.value;
    return true;
  }

  if (!force) {
    const hasExistingToken = await checkIfTokenIsSet();
    if (hasExistingToken) {
      return true;
    }
  }

  return await getToken();
}

async function getAudience() {
  try {
    let data = {
      action: 'getAudienceAll',
      id: terminData.value.wter_id,
    }
    console.log('getAudience', data)
    const response = await baseCalls.webinarPost(data);

    if (response.data.success == true) {
      audience.value = response.data.audience;
    }
  } catch (error) {
    console.error('Fehler beim Laden der Audience:', error);
    if (error.code === 'NETWORK_ERROR' || error.message === 'Network Error') {
      console.log('Netzwerkfehler beim Laden der Audience');
    }
  }
}

function getNameFromTeilnehmer(identity,what = 'name') {
  if(audience.value.length > 0) {
    // Extrahiert die Nummer nach dem Unterstrich: "audience_282" -> "282"
    const parts = identity.split('_');
    const id = parts[parts.length - 1]; // Nimmt das letzte Element nach dem Split
    if(what == 'name') {
      return audience.value.find(item => item.wteil_id == id)?.wteil_pers_name || identity;
    }
    if(what == 'admin') {
      return audience.value.find(item => item.wteil_id == id)?.wteil_is_admin || false;
    }
  }
  return identity;
}

function formatTime(timestamp) {
  const date = new Date(timestamp);
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  return `${hours}:${minutes}`;
}

// Teilnehmerliste aktualisieren
function updateAllTeilnehmerInRoom() {
  if (!room.value || !room.value.participants) {
    allTeilnehmerInRoom.value = [];
    return;
  }
  
  console.log('🔄 Aktualisiere Teilnehmerliste');
  
  const participantsArray = Array.from(room.value.participants.values());
  const allParticipants = [room.value.localParticipant, ...participantsArray];
  
  allTeilnehmerInRoom.value = allParticipants.map(participant => ({
    identity: participant.identity,
    sid: participant.sid,
    state: participant.state,
    isLocal: participant === room.value.localParticipant,
    videoTracks: participant.videoTracks ? participant.videoTracks.size : 0,
    audioTracks: participant.audioTracks ? participant.audioTracks.size : 0,
    dataTracks: participant.dataTracks ? participant.dataTracks.size : 0
  }));
  
  console.log('👥 Teilnehmer:', allTeilnehmerInRoom.value.length);
}

// Participant-Handling
function setupParticipant(participant) {
  console.log('👤 Setup:', participant.identity);
  
  // Zuerst Teilnehmerliste aktualisieren, damit Container erstellt werden
  updateAllTeilnehmerInRoom();
  
  participant.tracks.forEach(publication => {
    console.log('🔎 Publication gefunden:', publication.kind, publication.trackName, 'sid:', publication.trackSid, 'isSubscribed:', publication.isSubscribed);

    // Admin-Video ggf. proaktiv abonnieren
    if (publication.kind === 'video') {
      try {
        // Admin-Priorität hochsetzen
        if (participant.identity.startsWith('admin_') && typeof publication.setPriority === 'function') {
          publication.setPriority('high');
          console.log('⬆️ Priority high gesetzt für admin Video');
        }
      } catch (e) {
        console.warn('⚠️ setPriority fehlgeschlagen:', e);
      }
    }

    // Für Admin-Teilnehmer proaktiv abonnieren, falls möglich
    if (publication.kind === 'video' && participant.identity.startsWith('admin_')) {
      try {
        if (!publication.isSubscribed && typeof publication.subscribe === 'function') {
          console.log('📡 Versuche admin Video-Track zu abonnieren:', publication.trackSid);
          publication.subscribe();
        }
  } catch (e) {
        console.warn('⚠️ subscribe() auf Publication fehlgeschlagen:', e);
      }
    }

    if (publication.isSubscribed && publication.track) {
      console.log('📺 Bereits subscribed track:', publication.track.kind, participant.identity);
      attachTrack(publication.track, participant);
      if (publication.kind === 'video' && !participant.identity.startsWith('admin_')) {
        audienceIdentityHasVideo.value[participant.identity] = true;
      }
    }
    
    publication.on('subscribed', track => {
      console.log(`✅ Track subscribed: ${track.kind}`, participant.identity);
      attachTrack(track, participant);
      updateAllTeilnehmerInRoom();
      if (track.kind === 'video' && !participant.identity.startsWith('admin_')) {
        audienceIdentityHasVideo.value[participant.identity] = true;
      }
    });
    
    publication.on('unsubscribed', track => {
      console.log(`❌ Track unsubscribed: ${track.kind}`, participant.identity);
      detachTrack(track);
      updateAllTeilnehmerInRoom();
      if (track.kind === 'video' && !participant.identity.startsWith('admin_')) {
        audienceIdentityHasVideo.value[participant.identity] = false;
      }
    });
  });

  // Proaktives Binden existierender DataTracks (falls bereits subscribed)
  try {
    const dataPubs = Array.from(participant.dataTracks?.values?.() || []);
    dataPubs.forEach(pub => {
      if (pub && pub.track) {
        console.log('🔗 Binde vorhandenen DataTrack:', participant.identity, pub.track.sid);
        attachDataTrack(pub.track, participant);
      }
    });
  } catch (e) {
    console.warn('Proaktives DataTrack-Binden fehlgeschlagen:', e);
  }
  
  participant.on('trackPublished', publication => {
    console.log(`📤 Track published: ${publication.kind}`, participant.identity);
    
    // DataTrack publications proaktiv subscriben für Audience-zu-Audience Kommunikation
    if (publication.kind === 'data' && !publication.isSubscribed) {
      console.log('📡 DataTrack published, subscribiere proaktiv:', participant.identity);
      // Track wird automatisch subscribed durch automaticSubscription: true
      // Aber wir loggen es explizit für Debugging
    }
    
    updateAllTeilnehmerInRoom();
  });

  participant.on('trackSubscribed', track => {
    console.log(`🎥 trackSubscribed: ${track.kind}`, participant.identity);
    attachTrack(track, participant);
    updateAllTeilnehmerInRoom();
    if (track.kind === 'video' && !participant.identity.startsWith('admin_')) {
      audienceIdentityHasVideo.value[participant.identity] = true;
    }
    // DataTrack proaktiv binden (wichtig für Audience-zu-Audience Kommunikation)
    if (track.kind === 'data') {
      console.log('📡 DataTrack subscribed, binde explizit:', participant.identity);
      attachDataTrack(track, participant);
    }
  });

  participant.on('trackUnsubscribed', track => {
    console.log(`🚫 trackUnsubscribed: ${track.kind}`, participant.identity);
    detachTrack(track);
    updateAllTeilnehmerInRoom();
    if (track.kind === 'video' && !participant.identity.startsWith('admin_')) {
      audienceIdentityHasVideo.value[participant.identity] = false;
        }
      });
    }
 
function teardownParticipant(participant) {
  console.log('👋 Teardown:', participant.identity);
  const container = document.getElementById(`participant-${participant.sid}`);
  if (container) container.innerHTML = '';
}

// Track-Verwaltung
function attachTrack(track, participant) {
      if (track.kind === 'video') {
    attachVideoTrack(track, participant);
  } else if (track.kind === 'audio') {
    attachAudioTrack(track, participant);
  } else if (track.kind === 'data') {
    attachDataTrack(track, participant);
  }
}

function scheduleAudioUnlockListener() {
  if (audioUnlockHandler) {
    return;
  }
  audioUnlockHandler = async () => {
    await resumePendingAudioPlayback();
  };
  document.addEventListener('click', audioUnlockHandler);
}

function teardownAudioUnlockListener() {
  if (!audioUnlockHandler) {
    return;
  }
  document.removeEventListener('click', audioUnlockHandler);
  audioUnlockHandler = null;
}

async function attemptAudioPlayback(audioEl) {
  if (!audioEl) return;
  pendingAudioElements.add(audioEl);
  try {
    await audioEl.play();
    pendingAudioElements.delete(audioEl);
    if (pendingAudioElements.size === 0) {
      audioPlaybackBlocked.value = false;
      teardownAudioUnlockListener();
    }
  } catch (error) {
    console.warn('Audio autoplay blockiert:', error);
    audioPlaybackBlocked.value = true;
    scheduleAudioUnlockListener();
  }
}

async function resumePendingAudioPlayback() {
  if (pendingAudioElements.size === 0) {
    audioPlaybackBlocked.value = false;
    teardownAudioUnlockListener();
    return;
  }

  const attempts = Array.from(pendingAudioElements);
  for (const audioEl of attempts) {
    try {
      await audioEl.play();
      pendingAudioElements.delete(audioEl);
    } catch (error) {
      console.warn('Audio Unlock fehlgeschlagen:', error);
    }
  }

  audioPlaybackBlocked.value = pendingAudioElements.size > 0;
  if (audioPlaybackBlocked.value) {
    scheduleAudioUnlockListener();
  } else {
    teardownAudioUnlockListener();
  }
}

async function unlockAudioPlayback() {
  await resumePendingAudioPlayback();
}

async function attachVideoTrack(track, participant) {
  console.log('🎥 Attach video:', participant.identity, 'Track SID:', track.sid);
  
  // Warte auf Vue DOM-Update
  await nextTick();
  
  let container;
  let containerName;
  
      if (participant.identity.startsWith('admin_')) {
    // Admin-Video: Wähle Container basierend auf Präsentationsstatus
    if (presentationStarted.value) {
      containerName = 'admin-videos-inline';
    } else {
      containerName = 'admin-videos-fullsize';
    }
    container = document.getElementById(containerName);
    console.log('🎥 Admin-Video Container:', containerName);
  } else if (showInlineVideoIdentity.value === participant.identity) {
    // Audience-Video soll im Inline-Overlay (unten rechts) angezeigt werden
    // Wähle Container basierend auf Präsentationsstatus
    if (presentationStarted.value) {
      containerName = 'audience-video-inline';
    } else {
      containerName = 'audience-video-inline-fullsize';
    }
    container = document.getElementById(containerName);
    console.log('🎥 Audience-Video Inline Container:', containerName, 'Gefunden:', !!container);
  } else {
    containerName = `video-container-${participant.identity.replace('_', '-')}`;
    container = document.getElementById(containerName);
  }
  
  console.log('🔍 Suche Container:', containerName, 'Gefunden:', !!container);
  
  if (!container) {
    console.warn('❌ Container nicht gefunden für', participant.identity, containerName);
    
    // Warte kurz und versuche nochmal (Vue braucht Zeit für DOM-Update)
    setTimeout(async () => {
      await nextTick();
      const retryContainer = document.getElementById(containerName);
      if (retryContainer) {
        console.log('✅ Container nach Retry gefunden:', containerName);
        attachVideoToContainer(track, participant, retryContainer);
      } else {
        console.error('❌ Container auch nach Retry nicht gefunden:', containerName);
      }
    }, 300);
    return;
  }
  
  attachVideoToContainer(track, participant, container);
}

function attachVideoToContainer(track, participant, container) {
  // Wenn ein Vue-Container verwendet wird, .video-area als Ziel nutzen
  const target = container.querySelector('.video-area') || container;
  const existing = target.querySelector(`[data-track-id="${track.sid}"]`);
  if (existing) {
    console.log('🔄 Video bereits vorhanden');
      return;
    }
    
  console.log('📹 Erstelle Video-Element für:', participant.identity);

  const el = track.attach();
  el.setAttribute('data-track-id', track.sid);
  el.setAttribute('data-participant-identity', participant.identity);
        el.style.width = '100%';
        el.style.height = '100%';
        el.style.objectFit = 'cover';
        el.style.borderRadius = '0px';
  el.autoplay = true;
  el.playsInline = true;
  // Alle Remote-Videos stumm schalten, um Autoplay-Blocker zu vermeiden
  el.muted = true;
  
  // Explizit play() aufrufen, falls autoplay nicht funktioniert
  el.play().catch(err => {
    console.warn('⚠️ Video play() fehlgeschlagen:', err);
    // Wenn play() fehlschlägt, nochmal mit muted versuchen
    el.muted = true;
    el.play().catch(e => console.error('❌ Video play() final gescheitert:', e));
  });

  // Für Nicht-Admin nur einen Track zeigen: Container leeren
  if (!participant.identity.startsWith('admin_')) {
    // Entferne nur zuvor eingefügte Track-Elemente, nicht den gesamten Vue-Inhalt
    Array.from(target.querySelectorAll('[data-track-id]')).forEach(n => n.remove());
  }

  // Admin-Video einfügen (direkt in Container - fullsize oder inline)
  if (participant.identity.startsWith('admin_')) {
    // Entferne nur zuvor eingefügte Track-Elemente, nicht den gesamten Vue-Inhalt
    Array.from(target.querySelectorAll('[data-track-id]')).forEach(n => n.remove());
  }
  target.appendChild(el);

  // Markiere, dass dieser Participant ein Video hat
  if (!participant.identity.startsWith('admin_')) {
    audienceIdentityHasVideo.value[participant.identity] = true;
  } else {
    // Admin hat Video gestartet
    hasAdminVideo.value = true;
  }

  console.log('✅ Video angezeigt in:', (target.id || container.id), 'Size:', el.videoWidth, 'x', el.videoHeight);

  // Debug nach 1 Sekunde
          setTimeout(() => {
    console.log('🔍 Video Status nach 1s:', {
      container: container.id,
      videoWidth: el.videoWidth,
      videoHeight: el.videoHeight,
              readyState: el.readyState,
      paused: el.paused
            });
          }, 1000);
}

function attachAudioTrack(track, participant) {
  console.log('🎤 Attach audio:', participant.identity);
  
  const existing = document.querySelector(`[data-audio-track-id="${track.sid}"]`);
  if (existing) return;
  
  const audioEl = track.attach();
  audioEl.setAttribute('data-audio-track-id', track.sid);
  audioEl.setAttribute('data-participant-identity', participant.identity);
  audioEl.autoplay = true;
  audioEl.playsInline = true;
  audioEl.muted = false;
  audioEl.volume = 1;
  audioEl.controls = false;
  audioEl.style.display = 'none';
  document.body.appendChild(audioEl);
  attemptAudioPlayback(audioEl);
  console.log('✅ Audio attached');
  
  // Markiere dass dieser Participant Audio hat (für Audio-Only Anzeige)
  if (!participant.identity.startsWith('admin_')) {
    audienceIdentityHasAudio.value[participant.identity] = true;
  } else {
    hasAdminAudio.value = true;
  }
}

function detachTrack(track) {
  console.log('🗑️ Detach track:', track.sid, track.kind);
  
  // Finde das Element über data-track-id oder data-audio-track-id
  const selector = track.kind === 'audio' 
    ? `[data-audio-track-id="${track.sid}"]`
    : `[data-track-id="${track.sid}"]`;
    
  const elements = document.querySelectorAll(selector);
  elements.forEach(el => {
    console.log('🗑️ Entferne Element:', el.tagName);
    const identity = el.getAttribute('data-participant-identity');
    if (identity) {
      if (!identity.startsWith('admin_')) {
        if (track.kind === 'video') {
          audienceIdentityHasVideo.value[identity] = false;
        } else if (track.kind === 'audio') {
          audienceIdentityHasAudio.value[identity] = false;
      }
    } else {
        // Admin Video wurde entfernt
        if (track.kind === 'video') {
          hasAdminVideo.value = false;
        } else if (track.kind === 'audio') {
          hasAdminAudio.value = false;
        }
      }
    }
    if (track.kind === 'audio') {
      pendingAudioElements.delete(el);
      if (pendingAudioElements.size === 0) {
        audioPlaybackBlocked.value = false;
        teardownAudioUnlockListener();
      }
    }
    el.remove();
  });
}

function sendDataMessage(message) {
  const track = getMyDataTrack();
  if (!track) {
    console.warn('Kein lokaler DataTrack gefunden');
    return false;
  }
  try {
    const messageText = typeof message === 'string' ? message : JSON.stringify(message);
    track.send(messageText);
    console.log('📤 Gesendet:', message);

    // Gesendete Nachricht lokal zur Anzeige hinzufügen
    addDataTrackMessage({
      from: myIdentity.value,
      content: messageText
    });

    return true;
  } catch (e) {
    console.error('Senden fehlgeschlagen:', e);
    return false;
  }
}
function getMyDataTrack() {
  return localDataTrack.value || null;
}

// Hilfsfunktion: gesendete Nachricht in das bestehende Nachrichtenformat überführen
function addDataTrackMessage(msg) {
  try {
    const text = typeof msg === 'string' ? msg : (msg.content || '');
    let payload;
    try { payload = JSON.parse(text); } catch (_) { payload = { type: 'text', text }; }
    const newMessage = {
      from: msg.from || 'Sie',
      ts: Date.now(),
      payload
    };
    pushDataTrackMessage(newMessage);
    handleDataPayload(payload, newMessage.from);
  } catch (e) {
    console.warn('addDataTrackMessage fehlgeschlagen:', e);
  }
}

// Debug-Liste (showDebug) auf die letzten 200 Nachrichten begrenzen
function pushDataTrackMessage(message) {
  const list = [...dataTrackMessages.value, message];
  dataTrackMessages.value = list.length > 200 ? list.slice(-200) : list;
}

// DataTrack Handling
function attachDataTrack(track, participant) {
  console.log('💬 Attach data track from', participant.identity, 'Track:', track);
  
  // Wenn bereits gebunden, nicht erneut binden
  if (track._eventListenersBound) {
    console.log('⚠️ DataTrack bereits gebunden für', participant.identity);
    return;
  }
  
  const handler = (msg) => {
    console.log('📩 RAW DataTrack message empfangen von', participant.identity, ':', msg);
    let parsed;
    try {
      const text = typeof msg === 'string' ? msg : new TextDecoder().decode(msg);
      console.log('📩 DataTrack Text:', text);
      try { parsed = JSON.parse(text); } catch (_) { parsed = { type: 'text', text }; }
      console.log('📩 DataTrack Parsed:', parsed);
      
      const newMessage = {
        from: participant.identity,
        ts: Date.now(),
        payload: parsed,
      };
      
      pushDataTrackMessage(newMessage);
    } catch (e) {
      console.error('❌ DataTrack message parse error:', e);
      return;
    }
    handleDataPayload(parsed, participant.identity);
  };
  
  track.on('message', handler);
  console.log('✅ Event-Listener für DataTrack registriert:', participant.identity);
  
  // Markierung, um doppeltes Binden zu vermeiden
  track._eventListenersBound = true;
}

// Room Join
 async function joinRoom() {
  console.log('🔗 Joining room...');
  
  // Wenn bereits verbunden oder am Verbinden, abbrechen
  if (isConnected.value || isConnecting.value) {
    console.warn('⚠️ Bereits verbunden/verbindend - joinRoom abgebrochen');
    return;
  }

  // Falls ein alter Room noch existiert, sauber disconnecten
  if (room.value) {
    try {
      console.log('🔌 Alte Room-Verbindung wird geschlossen...');
      const oldRoom = room.value;
      room.value = null;
      isConnected.value = false;
      oldRoom.disconnect();
      // Warte bis Disconnect vollständig ist
      await new Promise(resolve => setTimeout(resolve, 1000));
    } catch (e) {
      console.warn('Fehler beim Disconnect alter Session:', e);
    }
  }
  
  isConnecting.value = true;

  const roomName = 'webinar_' + webinarTerminId.value;
  
  try {
    const dataTrack = new Video.LocalDataTrack({
        name: 'chat',
        ordered: true,
        reliable: true
      });
    localDataTrack.value = markRaw(dataTrack);
    
    const r = await Video.connect(token.value, { 
      name: roomName,
      // Identity kommt aus dem Token; nicht explizit überschreiben, um Duplikate zu verhindern
      tracks: [localDataTrack.value],
      audio: false,
      video: false,
      automaticSubscription: true,
      dominantSpeaker: false,
      preferredVideoCodecs: [{ codec: 'VP8', simulcast: false }],
      preferredAudioCodecs: ['opus'],
      bandwidthProfile: {
        video: {
          mode: 'presentation',
          maxTracks: 12,
          renderDimensions: {
            high: { width: 1280, height: 720 },
            standard: { width: 640, height: 360 },
            low: { width: 320, height: 180 }
          }
        }
      }
    });
    
    room.value = markRaw(r);
    isConnected.value = true;
    showBrowserTokenConflict.value = false; // Konflikt-Hinweis ausblenden bei erfolgreicher Verbindung
    console.log('✅ Verbunden');

    // Echte Teilnahme markieren (Basis fürs Teilnahmezertifikat)
    baseCalls.webinarPost({
      action: 'markAttended',
      id: route.params.teilnahmeid,
      hash: route.params.hash,
    }).catch((e) => console.warn('markAttended fehlgeschlagen:', e));
    
    // Warte bis LocalDataTrack published ist, dann sende Registrierungs-Message
    const sendRegistrationMessage = () => {
      console.log('📡 Sende Registrierungs-Nachricht');
      sendDataMessage({ type: 'newTeilnehmerRegistered', from: myIdentity.value, ts: Date.now() });
    };
    
    // Prüfe ob DataTrack bereits published ist
    const dataTrackPublished = Array.from(room.value.localParticipant.dataTracks.values()).length > 0;
    if (dataTrackPublished) {
      console.log('✅ DataTrack bereits published');
      sendRegistrationMessage();
    } else {
      // Warte auf trackPublished Event
      console.log('⏳ Warte auf DataTrack publish...');
      room.value.localParticipant.once('trackPublished', (publication) => {
        if (publication.kind === 'data') {
          console.log('✅ DataTrack published:', publication.trackSid);
          setTimeout(sendRegistrationMessage, 500); // Kurze Verzögerung für Stabilität
        }
      });
    }
    
    // Bereits vorhandene Teilnehmer
    const participants = Array.from(room.value.participants.values());
    console.log('👤 Teilnehmer:', participants.length);
    
    participants.forEach(participant => {
      setupParticipant(participant);
    });
    
    updateAllTeilnehmerInRoom();
    
    // Event Listener
    room.value.on('participantConnected', (participant) => {
      console.log('🔗 Participant joined:', participant.identity);
      setupParticipant(participant);
      updateAllTeilnehmerInRoom();

    // DataTracks sofort binden, wenn schon vorhanden
    try {
      const dataPubs = Array.from(participant.dataTracks?.values?.() || []);
      dataPubs.forEach(pub => {
        if (pub && pub.track) {
          console.log('🔗 (join) Binde vorhandenen DataTrack:', participant.identity, pub.track.sid);
          attachDataTrack(pub.track, participant);
        }
      });
    } catch (e) {
      console.warn('DataTrack-Bind (join) fehlgeschlagen:', e);
    }
    });
    
    room.value.on('participantDisconnected', (participant) => {
      console.log('🔌 Participant left:', participant.identity);
      teardownParticipant(participant);
      updateAllTeilnehmerInRoom();
    });

  // Raum-Disconnect behandeln
  room.value.on('disconnected', () => {
    console.log('🔌 Room disconnected');
    isConnected.value = false;
    isConnecting.value = false;
    room.value = null;
  });
  isConnecting.value = false;
  } catch (e) {
    console.error('❌ Connection error:', e);
  isConnected.value = false;
  room.value = null;
    isConnecting.value = false;
    // Bei Duplicate Identity: kurzen Backoff und erneut versuchen, falls die vorherige Session gerade schließt
    if (e && e.code === 53204 /* ParticipantDuplicateIdentityError */) {
      console.warn('Duplicate identity erkannt. Versuche erneut in 2s ...');
          setTimeout(() => {
        if (!isConnected.value && !isConnecting.value) {
          startSession();
        }
      }, 2000);
    }
  }
}

function stopAutoConnectLoop() {
  if (autoConnectTimer.value) {
    clearInterval(autoConnectTimer.value);
    autoConnectTimer.value = null;
  }
  autoConnectLoading.value = false;
  autoConnectMessage.value = '';
  showAutoConnectLoader.value = false; // Loader ausblenden
}

async function overrideBrowserToken() {
  console.log('🔓 User möchte Übertragung übernehmen – starte mit neuem browserToken');
  showBrowserTokenConflict.value = false;
  showAutoConnectLoader.value = false;
  await startWebinar();
}

async function attemptAutoConnect() {
  if (hasAdminVideo.value) {
    stopAutoConnectLoop();
    return;
  }

  // Prüfe browserToken vor jedem Auto-Connect Versuch
  const browserTokenAllowed = await checkBrowserTokenBeforeJoin();
  if (!browserTokenAllowed) {
    console.warn('⏸️ Auto-Connect gestoppt – anderes Gerät aktiv');
    stopAutoConnectLoop();
    return;
  }

  autoConnectAttempts.value += 1;
  autoConnectLoading.value = true;
  
  if (!isConnected.value) {
    autoConnectMessage.value = `Versuch ${autoConnectAttempts.value}: Wir verbinden Sie automatisch mit dem Webinar.`;

    try {
      if (terminData.value && terminData.value.open) {
        await startSession();
      } else {
        await getTerminData();
      }
    } catch (error) {
      console.warn('AutoConnect fehlgeschlagen:', error);
    }
  } else {
    autoConnectMessage.value = 'Verbindung steht, warte auf Dozenten-Video …';
  }
}

function startAutoConnectLoop() {
  
  if (autoConnectTimer.value || hasAdminVideo.value) return;
  autoConnectAttempts.value = 0;
  autoConnectLoading.value = true;
  showAutoConnectLoader.value = true; // Loader einblenden
  attemptAutoConnect();
  autoConnectTimer.value = setInterval(() => {
    if (!hasAdminVideo.value) {
      attemptAutoConnect();
    } else {
      stopAutoConnectLoop();
    }
  }, 20000);
}

async function checkBrowserTokenBeforeJoin() {
  try {
    // WICHTIG: Wenn Dozenten-Video läuft, browserToken-Check überspringen
    // User kann dann verbinden um laufendes Webinar zu sehen
    if (hasAdminVideo.value) {
      console.log('✅ Dozenten-Video läuft → browserToken-Check übersprungen');
      showBrowserTokenConflict.value = false;
      return true;
    }
    
    const data = {
      action: 'checkBrowserToken',
      id: route.params.teilnahmeid,
      hash: route.params.hash,
      browserToken: browserToken.value,
    };
    
    console.log('🔍 Prüfe browserToken vor Connect:', data);
    const response = await baseCalls.webinarPost(data);
    const result = response?.data || {};
    
    console.log('🔍 browserToken Check Ergebnis:', result);
    
    if (result.success && !result.allowed) {
      // BrowserToken stimmt nicht überein - anderes Gerät ist aktiv
      console.warn('⚠️ BrowserToken Konflikt erkannt:', result.message);
      autoConnectMessage.value = result.message || 'Diese Teilnahme ist bereits auf einem anderen Gerät aktiv.';
      stopAutoConnectLoop();
      showBrowserTokenConflict.value = true; // Zeige großen Hinweis mit Button
      return false; // Blockiere Join
    }
    
    // Token stimmt überein oder ist leer - darf connecten
    console.log('✅ BrowserToken Check OK:', result.message);
    showBrowserTokenConflict.value = false; // Hinweis ausblenden falls vorher sichtbar
    return true;
    
  } catch (error) {
    console.warn('⚠️ BrowserToken Check fehlgeschlagen, fahre vorsichtig fort:', error);
    return true; // Bei Fehler nicht blockieren
  }
}

// Session Start
async function startSession(options = {}) {
  const {
    forceTokenRefresh = false,
    showLoader = false,
    skipBrowserTokenCheck = false,
  } = options;

  if (isConnecting.value) {
    console.log('⏳ Verbindung läuft bereits – starte Session später erneut');
    return;
  }

  const shouldShowLoader = showLoader && !!loaderStore;
  if (shouldShowLoader) {
    loaderStore.setLoader(true, "Das Webinar wird gestartet...");
  }

  try {
    const tokenReady = await ensureToken({ force: forceTokenRefresh });
    if (!tokenReady) {
      console.warn('❌ Kein Token verfügbar, Session wird nicht gestartet.');
      return;
    }

    // Prüfe browserToken vor dem Connect (außer bei manuellem Start)
    if (!skipBrowserTokenCheck) {
      const browserTokenAllowed = await checkBrowserTokenBeforeJoin();
      if (!browserTokenAllowed) {
        console.warn('❌ Join wird verhindert – anderes Gerät ist aktiv');
        return;
      }
    } else {
      console.log('🔓 BrowserToken-Check übersprungen (manueller Start) – neuer Token wird gesetzt');
    }

    if (!isConnected.value) {
      await joinRoom();
    } else {
      console.log('⚠️ Bereits verbunden');
    }
  } catch (error) {
    console.error('🎬 startSession Fehler:', error);
  } finally {
    if (shouldShowLoader) {
      setTimeout(() => loaderStore.setLoader(false), 2000);
    }
  }
}

// Token holen
async function checkIfTokenIsSet() {
  try {
    const data = {
      action: 'checkIfTokenIsSet',
      id: route.params.teilnahmeid,
      hash: route.params.hash,
      admin: 0,
      browserToken: browserToken.value,
    };
  
    const response = await baseCalls.webinarPost(data);
    if (response.data.success) {
      token.value = response.data.token;
      userStore.setToken(response.data.token);
      userStore.setWebinarTerminId(response.data.terminId);
      webinarTerminId.value = response.data.terminId;
      console.log('✅ Bereits vorhandenen Token gefunden');
      return true;
    }
  } catch (error) {
    console.warn('checkIfTokenIsSet fehlgeschlagen:', error);
  }
  return false;
}

// Termin-Daten laden
async function getTerminData() {
  const data = {
    action: 'getTerminData',
    id: route.params.teilnahmeid,
    hash: route.params.hash,
    browserToken: browserToken.value,
  };
  
  const response = await baseCalls.webinarPost(data);
  console.log('getTerminData', response.data);
  
  if (response.data.success) {
    terminData.value = response.data.terminData;
    if (response.data.user) {
      userStore.setUser(response.data.user);
    }
    
    // Setze slideShowNumber aus Webinar-ID (webi_id)
    if (terminData.value.wter_webinar_id) {
      slideShowNumber.value = terminData.value.wter_webinar_id;
      console.log('✅ slideShowNumber gesetzt:', slideShowNumber.value, '→ /videos/webinar' + slideShowNumber.value + '/slides/');
    }
    
    if (terminData.value.open) {
      userStore.setWebinarTerminId(terminData.value.id);
      getAudience();
      getWebinarStats();
      // startSession() wird vom Auto-Connect-Loop aufgerufen
    }

    // Fragen des Termins laden und Status (beantwortet) regelmäßig aktualisieren
    loadQuestions();
    if (!terminData.value.beendet) {
      startQuestionPolling();
    }
  }
}

// Watcher
watch(room, (newRoom) => {
  if (newRoom) {
    updateAllTeilnehmerInRoom();
  }
});

watch(() => terminData.value.open, (newValue) => {
  console.log('🔄 terminData.open:', newValue);
  // startSession() wird vom Auto-Connect-Loop aufgerufen, nicht hier
});

watch(isConnected, (connected) => {
  if (!connected && !autoConnectTimer.value && !hasAdminVideo.value) {
    startAutoConnectLoop();
  }
  // Nach (Re-)Connect verpasste Fragen/Status nachholen
  if (connected) {
    loadQuestions();
  }
});

watch(() => hasAdminVideo.value, (newValue) => {
  if (newValue) {
    stopAutoConnectLoop();
    showBrowserTokenConflict.value = false; // Konflikt-Warnung ausblenden wenn Webinar läuft
  } else if (!autoConnectTimer.value) {
    startAutoConnectLoop();
  }
});

// Watcher für presentationStarted - Video zwischen Containern verschieben
watch(presentationStarted, async (newValue, oldValue) => {
    if (slideShowNumber.value ==  0) {
      return false
    }
  console.log('🔄 presentationStarted changed:', oldValue, '->', newValue);
  
  if (presentationView.value === 'inline') {
    // Admin Video VOR Template-Switch retten
    let adminVideosToMove = [];
    
    const currentAdminContainer = oldValue ? 
      document.getElementById('admin-videos-inline') : 
      document.getElementById('admin-videos-fullsize');
    
    if (currentAdminContainer) {
      adminVideosToMove = Array.from(currentAdminContainer.querySelectorAll('video'));
      console.log('🎥 Admin-Videos vor Template-Switch gerettet:', adminVideosToMove.length);
    }
    
    // Audience Inline Video VOR Template-Switch retten
    let audienceInlineVideo = [];
    const currentAudienceInlineContainer = oldValue ?
      document.getElementById('audience-video-inline') :
      document.getElementById('audience-video-inline-fullsize');
      
    if (currentAudienceInlineContainer) {
      audienceInlineVideo = Array.from(currentAudienceInlineContainer.querySelectorAll('video'));
      console.log('🎥 Audience-Inline-Video vor Template-Switch gerettet:', audienceInlineVideo.length);
    }
    
    // Warten auf DOM-Update
    await nextTick();
    
    // Ziel-Container nach Template-Switch finden
    const newAdminContainer = newValue ? 
      document.getElementById('admin-videos-inline') : 
      document.getElementById('admin-videos-fullsize');
    
    const newAudienceInlineContainer = newValue ?
      document.getElementById('audience-video-inline') :
      document.getElementById('audience-video-inline-fullsize');
    
    // Gerettete Admin-Videos in neuen Container verschieben
    if (adminVideosToMove.length > 0 && newAdminContainer) {
      adminVideosToMove.forEach(video => {
        console.log('🎥 Verschiebe Admin-Video zu', newAdminContainer.id);
        video.style.width = '100%';
        video.style.height = '100%';
        video.style.objectFit = 'cover';
        newAdminContainer.appendChild(video);
      });
      console.log('✅ Admin-Videos verschoben');
    }
    
    // Gerettete Audience-Inline-Videos verschieben
    if (audienceInlineVideo.length > 0 && newAudienceInlineContainer) {
      audienceInlineVideo.forEach(video => {
        console.log('🎥 Verschiebe Audience-Inline-Video zu', newAudienceInlineContainer.id);
        video.style.width = '100%';
        video.style.height = '100%';
        video.style.objectFit = 'cover';
        newAudienceInlineContainer.appendChild(video);
      });
      console.log('✅ Audience-Inline-Video verschoben');
                    }
                  }
                });
                
watch(allTeilnehmerInRoom, (newList) => {
  console.log('📋 Teilnehmerliste geändert:', newList.length, 'Teilnehmer');
  newList.forEach(p => {
    console.log('  -', p.identity, '| Video:', p.videoTracks, '| Audio:', p.audioTracks);
  });
  // Sicherstellen, dass nur Teilnehmer mit Video angezeigt werden
  newList.forEach(p => {
    if (p.identity.startsWith('audience_')) {
    
      // Falls kein Video-Track registriert ist, flag zurücksetzen
      if (!p.videoTracks || p.videoTracks === 0) {
        audienceIdentityHasVideo.value[p.identity] = !!document.querySelector(`#video-container-${p.identity.replace('_','-')} [data-track-id]`);
      }
    }
  });
}, { deep: true });

// Watcher für showInlineVideoIdentity - Audience-Video in Inline-Overlay verschieben
watch(showInlineVideoIdentity, async (newIdentity, oldIdentity) => {
  console.log('🔄 showInlineVideoIdentity changed:', oldIdentity, '->', newIdentity);
  
  // Inline-Video funktioniert auch ohne Präsentation (dann im fullsize Container)
  if (!isConnected.value || !room.value) {
    console.log('⚠️ Nicht verbunden, kann Inline-Video nicht anzeigen');
    return;
  }
  
  // Altes Video zurück in normalen Container verschieben
  if (oldIdentity && room.value) {
    // Zuerst alle Video-Elemente des alten Participants aus Inline-Containern entfernen
    const oldInlineContainer = document.getElementById('audience-video-inline');
    const oldInlineFullsizeContainer = document.getElementById('audience-video-inline-fullsize');
    
    [oldInlineContainer, oldInlineFullsizeContainer].forEach(container => {
      if (container) {
        const videos = Array.from(container.querySelectorAll('video'));
        videos.forEach(v => {
          if (v.getAttribute('data-participant-identity') === oldIdentity) {
            console.log('🗑️ Entferne Video aus Inline-Container');
            v.remove();
          }
        });
      }
    });
    
    // Dann Video neu attachen in normalem Container
    const oldParticipant = Array.from(room.value.participants.values()).find(p => p.identity === oldIdentity);
    if (oldParticipant) {
      oldParticipant.videoTracks.forEach(pub => {
        if (pub.track) {
          console.log('🔄 Verschiebe altes Video zurück:', oldIdentity);
          attachVideoTrack(pub.track, oldParticipant);
        }
      });
    }
  }
  
  // Neues Video in Inline-Container verschieben
  if (newIdentity && room.value) {
    await nextTick();
    
    // Zuerst Video aus normalem Container entfernen
    const normalContainer = document.getElementById(`video-container-${newIdentity.replace('_', '-')}`);
    if (normalContainer) {
      const videoArea = normalContainer.querySelector('.video-area');
      if (videoArea) {
        const videos = Array.from(videoArea.querySelectorAll('video'));
        videos.forEach(v => {
          if (v.getAttribute('data-participant-identity') === newIdentity) {
            console.log('🗑️ Entferne Video aus normalem Container');
            v.remove();
          }
        });
      }
    }
    
    // Dann Video neu attachen in Inline-Container
    const newParticipant = Array.from(room.value.participants.values()).find(p => p.identity === newIdentity);
    if (newParticipant) {
      newParticipant.videoTracks.forEach(pub => {
        if (pub.track) {
          console.log('🔄 Verschiebe Video in Inline-Overlay:', newIdentity);
          attachVideoTrack(pub.track, newParticipant);
        }
      });
    }
  }
});

// Mounted
onMounted(async () => {
  // BrowserToken zur URL hinzufügen falls nicht vorhanden
  if (!route.params.browserToken && browserToken.value) {
    try {
      const newPath = `/watch/${route.params.teilnahmeid}/${route.params.hash}/${browserToken.value}`;
      await router.replace(newPath);
      console.log('✅ BrowserToken zur URL hinzugefügt:', newPath);
    } catch (error) {
      console.warn('⚠️ URL-Update fehlgeschlagen:', error);
    }
  }
  
  await getTerminData();
  startAutoConnectLoop();
  updateDocumentHead(
    "Webinar - Webinare für Zahnärzte & ZFA",
    "Webinare für Zahnärzte & ZFA"
  );
});

onBeforeUnmount(() => {
  try {
    if (room.value && typeof room.value.disconnect === 'function') {
      room.value.disconnect();
    }
      } catch (e) {
    console.warn('Fehler beim Disconnect auf Unmount:', e);
  }
  stopAutoConnectLoop();
  stopQuestionPolling();
  teardownAudioUnlockListener();
  pendingAudioElements.forEach((el) => {
    try {
      el.pause();
    } catch (_) {
      /* ignore */
    }
  });
  pendingAudioElements.clear();
  audioPlaybackBlocked.value = false;
});

// Helper
function hasVideo(identity) {
  return !!audienceIdentityHasVideo.value[identity];
}

function hasAudio(identity) {
  return !!audienceIdentityHasAudio.value[identity];
}

// Präsentations-Funktionen
function getUpcomingVideoSlides() {
  const slides = currentWebinarSlides.value;
  if (!slides || !activePictureBroadCast.value.url) return [];
  
  const currentIndex = Object.values(slides).findIndex(
    slide => slide.url === activePictureBroadCast.value.url
  );
  
  return Object.values(slides)
    .slice(currentIndex + 1, currentIndex + 4)
    .filter(slide => slide.type === 'video');
}

function getUpcomingImageSlides() {
  const slides = currentWebinarSlides.value;
  if (!slides || !activePictureBroadCast.value.url) return [];
  
  const currentIndex = Object.values(slides).findIndex(
    slide => slide.url === activePictureBroadCast.value.url
  );
  
  return Object.values(slides)
    .slice(currentIndex + 1, currentIndex + 4)
    .filter(slide => slide.type === 'picture');
}

// Mein Broadcast: Start/Stop und Attachment in #mein-broadcast
async function startMyBroadcast() {
  try {
    console.log('🎬 startMyBroadcast aufgerufen');
    if (!room.value) {
      console.warn('❌ startMyBroadcast: kein Room verbunden');
      return;
    }
    
    // Video-Track nur erstellen wenn NICHT audioOnlyBroadcast
    if (!audioOnlyBroadcast.value) {
      console.log('📹 Erstelle Video-Track...');
      if (!localVideoTrack.value) {
        const track = await Video.createLocalVideoTrack({
          name: `video_${myIdentity.value}`,
          width: 640,
          height: 480
        });
        localVideoTrack.value = markRaw(track);
        console.log('✅ Video-Track erstellt:', localVideoTrack.value.sid);
      }
    } else {
      console.log('🎤 Audio-Only Modus: Video wird NICHT erstellt');
    }
    
    console.log('🎤 Erstelle Audio-Track...');
    if (!localAudioTrack.value) {
      const audioTrack = await Video.createLocalAudioTrack({
        name: `audio_${myIdentity.value}`
      });
      localAudioTrack.value = markRaw(audioTrack);
      console.log('✅ Audio-Track erstellt:', localAudioTrack.value.sid);
    }
    
    // Publish Video falls noch nicht geschehen (NUR wenn nicht audioOnlyBroadcast)
    if (!audioOnlyBroadcast.value && localVideoTrack.value) {
      const alreadyPublishedVideo = Array.from(room.value.localParticipant.videoTracks.values()).some(pub => pub.track && pub.track.sid === localVideoTrack.value.sid);
      console.log('🔍 Video bereits publiziert?', alreadyPublishedVideo);
      
      if (!alreadyPublishedVideo) {
        console.log('📤 Veröffentliche Video-Track...');
        await room.value.localParticipant.publishTrack(localVideoTrack.value);
        console.log('✅ Video-Track veröffentlicht');
      }
    } else if (audioOnlyBroadcast.value) {
      console.log('🎤 Audio-Only Modus: Video wird NICHT publiziert');
    }
    
    // Publish Audio falls noch nicht geschehen
    const alreadyPublishedAudio = Array.from(room.value.localParticipant.audioTracks.values()).some(pub => pub.track && pub.track.sid === localAudioTrack.value.sid);
    console.log('🔍 Audio bereits publiziert?', alreadyPublishedAudio);
    
    if (!alreadyPublishedAudio) {
      console.log('📤 Veröffentliche Audio-Track...');
      await room.value.localParticipant.publishTrack(localAudioTrack.value);
      console.log('✅ Audio-Track veröffentlicht');
    }
    
    // Nach Publish: Warte kurz und prüfe
    await new Promise(resolve => setTimeout(resolve, 500));
    const videoTracksCount = room.value.localParticipant.videoTracks.size;
    const audioTracksCount = room.value.localParticipant.audioTracks.size;
    console.log('📊 Tracks nach Publish - Video:', videoTracksCount, 'Audio:', audioTracksCount);
    updateAllTeilnehmerInRoom();

    // WICHTIG: Flag ZUERST setzen, damit v-if den Container rendert
    isMyBroadcasting.value = true;
    
    // Warte auf Vue DOM-Update
    await nextTick();
    
    // In #mein-broadcast anhängen (NUR Video, wenn nicht audioOnlyBroadcast)
    if (!audioOnlyBroadcast.value && localVideoTrack.value) {
      const container = document.getElementById('mein-broadcast') || document.getElementById('mein-broadcast-mobile');
      if (container) {
        const el = localVideoTrack.value.attach();
        el.style.width = '100%';
        el.style.height = '100%';
        el.style.objectFit = 'cover';
        el.autoplay = true;
        el.playsInline = true;
        el.muted = true; // Eigenes Video stumm
        container.innerHTML = '';
        container.appendChild(el);
        console.log('✅ Video in #mein-broadcast angezeigt');
      } else {
        console.warn('❌ #mein-broadcast container nicht gefunden');
        isMyBroadcasting.value = false; // Zurücksetzen wenn Container nicht da
      }
    } else if (audioOnlyBroadcast.value) {
      console.log('🎤 Audio-Only Modus: "Audio Live" Indikator wird angezeigt');
    }
  } catch (e) {
    console.error('❌ startMyBroadcast Fehler:', e);
    isMyBroadcasting.value = false;
  }
}

async function stopMyBroadcast() {
  try {
    console.log('⏹️ stopMyBroadcast aufgerufen');
    
    // Video-Track unpublish und stoppen
    if (room.value && localVideoTrack.value) {
      try {
        console.log('📤 Unpublish Video-Track...');
        await room.value.localParticipant.unpublishTrack(localVideoTrack.value);
        console.log('✅ Video-Track unpublished');
        
        // Track stoppen (Kamera freigeben)
        localVideoTrack.value.stop();
        localVideoTrack.value = null;
        console.log('🎥 Video-Track gestoppt');
	} catch (e) {
        console.warn('⚠️ Video unpublish/stop fehlgeschlagen:', e);
      }
    }
    
    // Audio-Track unpublish und stoppen
    if (room.value && localAudioTrack.value) {
      try {
        console.log('📤 Unpublish Audio-Track...');
        await room.value.localParticipant.unpublishTrack(localAudioTrack.value);
        console.log('✅ Audio-Track unpublished');
        
        // Track stoppen (Mikrofon freigeben)
        localAudioTrack.value.stop();
        localAudioTrack.value = null;
        console.log('🎤 Audio-Track gestoppt');
		} catch (e) {
        console.warn('⚠️ Audio unpublish/stop fehlgeschlagen:', e);
      }
    }
    
    // WICHTIG: Flag ZUERST auf false setzen, damit v-if den Container ausblendet
    isMyBroadcasting.value = false;
    
    // Container leeren (falls noch sichtbar) - beide Container prüfen
    const containerDesktop = document.getElementById('mein-broadcast');
    const containerMobile = document.getElementById('mein-broadcast-mobile');
    
    if (containerDesktop) {
      containerDesktop.innerHTML = '';
      console.log('🗑️ Desktop Container geleert');
    }
    if (containerMobile) {
      containerMobile.innerHTML = '';
      console.log('🗑️ Mobile Container geleert');
    }
    
    updateAllTeilnehmerInRoom();
    console.log('✅ Mein Broadcast gestoppt - Kamera & Mikrofon freigegeben, Container ausgeblendet');
  } catch (e) {
    console.warn('❌ stopMyBroadcast Fehler:', e);
  }
}

function sendReactionPilot(type) {
  console.log('👍 Sende Reaktion:', type);
  const reactionMessage = {
    type: type,
    from: myIdentity.value,
    timestamp: Date.now()
  };
  sendDataMessage(reactionMessage);
}

// Reaktionen senden
function sendReaction(type) {
  console.log('👍 Sende Reaktion:', type);
  const reactionMessage = {
    type: type,
    from: myIdentity.value,
    timestamp: Date.now()
  };
  sendDataMessage(reactionMessage);
  
  saveReaction(type);
  
  // Zeige Reaktions-Animation über Admin-Video
  showReactionAnimation(type);
  
  // Visuelles Feedback
  // Optional: Toast/Snackbar anzeigen
  console.log(`✅ Reaktion "${type}" gesendet`);
}

// Reaktions-Animation über Admin-Video anzeigen
function showReactionAnimation(type) {
  let icon = '';
  let color = '';
  
  switch(type) {
    case 'userDanke':
      icon = 'mdi-heart';
      color = '#F44336'; // rot
      break;
    case 'userInteressant':
      icon = 'mdi-fire';
      color = '#FF9800'; // orange
      break;
    case 'frage':
      icon = 'mdi-help-circle';
      color = '#2196F3'; // blau
      break;
    case 'userHallo':
      icon = 'mdi-human-greeting';
      color = '#2196F3'; // blau
      break;
  }
  
  // Animation einblenden
  reactionAnimation.value = {
    visible: true,
    icon: icon,
    color: color
  };
  
  // Nach 1 Sekunde wieder ausblenden
  setTimeout(() => {
    reactionAnimation.value.visible = false;
  }, 1000);
}

async function saveReaction(type) {
  let dataType = 0;
  if(type == 'userDanke') {
    dataType = 1;
  } else if(type == 'userInteressant') {
    dataType = 2;
  } else if(type == 'userHallo') {
    dataType = 3;
  }
  let data = {
    action: 'saveReaction',
    type: dataType,
    terminid: terminData.value.wter_id,
    teilnehmerid: route.params.teilnahmeid,
  }
  const response = await baseCalls.webinarPost(data);
  if (response.data.success == true) {
    console.log('✅ Reaktion gespeichert');
    getWebinarStats();
  } else {
    console.log('❌ Reaktion nicht gespeichert');
  }
}

async function getWebinarStats() {
  console.log('getWebinarStats');
  try {
    let data = {
      action: 'getWebinarStats',
      id: terminData.value.wter_id,
    }
    const response = await baseCalls.webinarPost(data);
    if (response.data.success == true) {
      webinarStats.value = response.data.stats;
    }
  } catch (error) {
    console.error('Fehler beim Laden der Fragen:', error);
    if (error.code === 'NETWORK_ERROR' || error.message === 'Network Error') {
      console.log('Netzwerkfehler - versuche später erneut');
      // Optional: Benachrichtigung für den User
    }
  }
}

// Jede DataTrack-Nachricht (empfangen oder selbst gesendet) einzeln verarbeiten.
// Früher lief das über einen Watcher auf das letzte Listenelement: Nachrichten im selben
// Tick gingen verloren und ab 200 Einträgen wurde gar nichts mehr verarbeitet (Folien!).
function handleDataPayload(payload, fromIdentity) {
  if (!payload || !payload.type) return;

  if(payload.type === 'showDankeDialog') {
    showDankeDialog.value = true;
  }

  if (payload.type === 'newTeilnehmerRegistered') {
    // Nur fremde Teilnehmer-Registrierungen anzeigen, nicht eigene
      console.log('🔍 Neuer Teilnehmer registriert:', payload.from);
      publicDataTrackMessages.value.unshift({ type: 'newTeilnehmerRegistered', from: payload.from || '' });
  
  }
  if (payload.type === 'jetzLiveImWebinar') {
    // Nur fremde Teilnehmer-Registrierungen anzeigen, nicht eigene
      console.log('🔍 Teilnehmer live zugeschaltet:', payload.from);
      publicDataTrackMessages.value.unshift({ type: 'jetzLiveImWebinar', from: payload.from || '' });
  
  }
  if (payload.type === 'userDanke') {
    // Nur fremde Teilnehmer-Registrierungen anzeigen, nicht eigene
      console.log('🔍 User Danke:', payload.from);
      publicDataTrackMessages.value.unshift({ type: 'userDanke', from: payload.from || '' });
  
  }
  if (payload.type === 'userHallo') {
    // Nur fremde Teilnehmer-Registrierungen anzeigen, nicht eigene
      console.log('🔍 User Hallo:', payload.from);
      publicDataTrackMessages.value.unshift({ type: 'userHallo', from: payload.from || '' });
  
  }
  if (payload.type === 'userInteressant') {
    // Nur fremde Teilnehmer-Registrierungen anzeigen, nicht eigene
      console.log('🔍 User Interessant:', payload.from);
      publicDataTrackMessages.value.unshift({ type: 'userInteressant', from: payload.from || '' });
  
  }
  if (payload.type === 'neueUserFragen') {
      console.log('🔍 Neue Frage:', payload.from);
      publicDataTrackMessages.value.unshift({ type: 'neueUserFragen', from: payload.from || '' });
  }
  if (payload.type === 'neueFragen' && payload.identity !== myIdentity.value) {
    scheduleQuestionReload();
  }
  if (payload.type === 'chatMessage' && (payload.from || fromIdentity) !== myIdentity.value) {
    addTeamMessageFromPayload(payload, fromIdentity);
  }
  // Präsentations-Messages (global, für alle)
  if (payload.type === 'pictureBroadCastStarted') {
    presentationStarted.value = true;
    console.log('📊 Präsentation gestartet');
  } else if (payload.type === 'pictureBroadCastEnded') {
    presentationStarted.value = false;
    showInlineVideoIdentity.value = null; // Inline-Video ausblenden
    console.log('📊 Präsentation beendet');
  } else if (payload.type === 'pictureBroadCast') {
    presentationStarted.value = true;
    if (payload.picture) {
      activePictureBroadCast.value.url = payload.picture.url;
      activePictureBroadCast.value.type = payload.picture.type;
      console.log('📊 Slide geändert:', payload.picture.url, payload.picture.type);
    }
  } else if (payload.type === 'showInlineVideo') {
    // Zeige Audience-Video im Inline-Overlay
    if (payload.identity && payload.identity !== myIdentity.value) {
      console.log('📺 Setze showInlineVideoIdentity:', payload.identity);
      console.log('  - presentationStarted:', presentationStarted.value);
      console.log('  - isConnected:', isConnected.value);
      showInlineVideoIdentity.value = payload.identity;
      console.log('  - showInlineVideoIdentity gesetzt auf:', showInlineVideoIdentity.value);
    } else {
      console.log('⏭️ Ignoriere showInlineVideo für eigene Identity');
    }
  } else if (payload.type === 'hideInlineVideo') {
    // Verstecke Inline-Video
    showInlineVideoIdentity.value = null;
    console.log('📺 Verstecke Inline-Video');
  }
  
  // Audience-spezifische Messages (nur für mich)
  const altTargets = [
    myIdentity.value,
    String(route.params.teilnahmeid),
    `audience_${String(route.params.teilnahmeid)}`
  ];
  if (AUDIENCE_LIVE_ENABLED && payload.to && altTargets.includes(String(payload.to))) {
    console.log('🔍 DataTrack Nachricht empfangen:', payload.type);
    if (payload.type === 'videoOn') {
      console.log('🔍 Teilnehmer wird gebroadcastet:', payload.identity);
      if (!isMyBroadcasting.value) startMyBroadcast();
    } else if (payload.type === 'videoOff') {
      stopMyBroadcast();
    }
  }
}
</script>

<style scoped>
/* Alle Rundungen entfernen */
.v-card,
.v-btn,
.v-chip {
  border-radius: 0 !important;
}

.audience-main-wrapper {
  width: 100%;
}

.audience-video-stage,
.audience-presentation-stage {
  width: 100%;
  max-width: 100%;
  aspect-ratio: 16 / 9;
  background: #000;
  position: relative;
  border-radius: 0;
}

.audience-video-stage {
  overflow: hidden;
}

.audience-presentation-stage {
  overflow: hidden;
}

.audience-presentation-media {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.audience-reactions-row {
  margin-top: 24px;
}

.audience-reactions-card {
  width: 100%;
  padding: 16px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 0;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.audience-reaction-buttons {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
}

.audience-reaction-btn {
  width: 100%;
  font-weight: bold;
}

.audience-reaction-copilot {
  margin-top: 16px;
}

.audio-unlock-banner {
  display: flex;
  align-items: center;
  border: 2px solid #ffa726;
  background: #fff7ef;
  padding: 12px 16px;
  border-radius: 0;
  gap: 12px;
}

.audio-test-banner {
  border: 2px solid #c5d7f2;
  background: #f7f9ff;
  padding: 12px 16px;
  border-radius: 0;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.1); opacity: 0.8; }
}

.pulse-animation {
  animation: pulse 2s ease-in-out infinite;
}

/* Reaktions-Animation */
.reaction-fade-enter-active, .reaction-fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.reaction-fade-enter-from {
  opacity: 0;
  transform: scale(0.5);
}

.reaction-fade-leave-to {
  opacity: 0;
  transform: scale(1.5);
}

.reaction-pulse {
  animation: reaction-pulse 1s ease-in-out;
}

@keyframes reaction-pulse {
  0% { 
    transform: scale(0.5); 
    opacity: 0; 
  }
  50% { 
    transform: scale(1.1); 
    opacity: 1; 
  }
  100% { 
    transform: scale(1); 
    opacity: 1; 
  }
}

/* Responsive Design für Mobile */
@media (max-width: 768px) {
  /* Kleinere Overlays auf Mobile */
  #audience-video-inline,
  #audience-video-inline-fullsize {
    width: 120px !important;
    height: 90px !important;
    bottom: 10px !important;
    right: 10px !important;
  }
}

.question-feed--compact {
  max-height: 220px;
}

/* Dozent neben der Präsentation */
.dozent-side-video {
  margin-bottom: 16px;
  background: #000;
  border: 2px solid #3d1b70;
  box-shadow: 0 4px 16px rgba(61, 27, 112, 0.15);
}

.dozent-side-video__stage {
  width: 100%;
  aspect-ratio: 4 / 3;
  background: #000;
  overflow: hidden;
}

.dozent-side-video__stage :deep(video) {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.dozent-side-video__placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1a1a2e 0%, #0f3460 100%);
}

.dozent-side-video__label {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  background: #3d1b70;
  color: #fff;
  font-weight: bold;
  font-size: 14px;
}

.dozent-side-video__live {
  background: #e53935;
  padding: 1px 6px;
  font-size: 11px;
  letter-spacing: 1px;
}

/* Fragen-Panel */
.audience-reaction-btn--frage {
  grid-column: 1 / -1;
  color: #fff;
}

@media (min-width: 960px) {
  .audience-side-column {
    position: sticky;
    top: 16px;
  }
}

.question-panel {
  border: 2px solid #3d1b70;
  background: #faf8fd;
  box-shadow: 0 4px 16px rgba(61, 27, 112, 0.15);
}

.question-panel__head {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  background: #3d1b70;
  color: #fff;
}

.question-panel__title {
  font-size: 20px;
  font-weight: bold;
  line-height: 1.2;
}

.question-panel__subtitle {
  font-size: 13px;
  opacity: 0.85;
  margin-top: 2px;
}

.question-panel__body {
  padding: 16px 16px 8px;
}

.question-panel__actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.question-feed {
  border-top: 1px solid #e3dcef;
  padding: 8px 16px 16px;
  max-height: 420px;
  overflow-y: auto;
}

.question-feed__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
  font-weight: bold;
  color: #3d1b70;
}

.question-feed__empty {
  padding: 12px 0;
  color: #888;
  text-align: center;
}

.question-item {
  padding: 10px 12px;
  margin-bottom: 8px;
  background: #fff;
  border-left: 4px solid #d6cce6;
}

.question-item--mine {
  border-left-color: #3d1b70;
  background: #f1ecf8;
}

.question-item--answered {
  border-left-color: #4caf50;
}

.question-item--team {
  border-left-color: #2196f3;
  background: #eef6fd;
}

.question-item__text {
  white-space: pre-wrap;
  word-break: break-word;
}

.question-item__meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 4px;
  font-size: 12px;
  color: #666;
}

.activity-panel {
  border: 4px solid #f2f2f2;
  padding: 10px;
}

.activity-message {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-bottom: 1px solid #eee;
}

.auto-connect-alert {
  border-radius: 0;
}

.dozent-avatar-wrapper {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 160px;
  height: 160px;
  border: 3px solid rgba(255,255,255,0.9);
  border-radius: 0;
  overflow: hidden;
  box-shadow: 0 6px 24px rgba(0,0,0,0.45);
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.dozent-avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0;
}

.dozent-avatar-fallback {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.admin-video-loader {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed #3d1b70;
  padding: 12px 18px;
  color: #3d1b70;
  text-align: left;
  border-radius: 0;
}
</style>
